// src/accordion/index.tsx
import { Accordion as PrimeAccordion } from "primereact/accordion";

// src/accordion/components/accordion-tab/index.tsx
import { AccordionTab as PrimeAccordionTab } from "primereact/accordion";
import { jsx } from "react/jsx-runtime";
function AccordionTab({ children, ...props }) {
  return /* @__PURE__ */ jsx(PrimeAccordionTab, { ...props, children });
}
AccordionTab.defaultProps = {
  __TYPE: "AccordionTab",
  pt: {
    root: {
      className: "m-0"
    },
    content: {
      className: "border-t"
    }
  }
};

// src/accordion/index.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function Accordion({ children, ...props }) {
  return /* @__PURE__ */ jsx2(
    PrimeAccordion,
    {
      pt: {
        root: {
          className: "w-full rounded-md border shadow-sm shadow-slate-500"
        }
      },
      ...props,
      children
    }
  );
}

// src/action-link/index.tsx
import { Link } from "react-router-dom";

// src/utils/cn/index.ts
import { classNames } from "primereact/utils";
import { twMerge } from "tailwind-merge";
function cn(...args) {
  return twMerge(classNames(...args));
}

// src/button/buttons.styles.ts
function buttonStyles({
  className,
  disabled,
  fullSize = false,
  isLoading,
  orientation = "horizontal",
  rounded,
  size = "medium",
  spacing = "initial",
  variant = "primary"
}) {
  const isPrimary = variant === "primary";
  const isSecondary = variant === "secondary";
  const isInfo = variant === "info";
  const isText = variant === "text";
  const isLinkPrimary = variant === "link-primary";
  const isLinkSecondary = variant === "link-secondary";
  const isLinkInfo = variant === "link-info";
  const isOutlined = variant === "outlined";
  const isOutlinedInfo = variant === "outlined-info";
  const isSizeExtraSmall = size === "extra-small";
  const isSizeSmall = size === "small";
  const isSizeMedium = size === "medium";
  const isSpacingNone = spacing === "none";
  const isOrientationVertical = orientation === "vertical";
  return cn(
    "py-2 uppercase text-sm transition-all p-ripple border border-transparent rounded-lg",
    className,
    {
      "bg-primary text-white border-primary hover:border-primary/80 hover:bg-primary/80 shadow-md": isPrimary,
      "bg-white text-secondary hover:bg-slate-50 border border-secondary shadow-md": isSecondary,
      "bg-blue text-white hover:bg-info/80 border border-info/80 shadow-md": isInfo,
      "text-primary hover:text-primary/80 border border-purple/50 hover:border-purple/75": isText,
      "bg-transparent text-primary hover:text-primary/80 border border-transparent border-primary hover:border-primary/80": isOutlined,
      "bg-transparent text-blue hover:text-blue/80 border border-transparent border-blue hover:border-blue/80": isOutlinedInfo,
      "p-2 text-primary": isLinkPrimary,
      "p-2 text-secondary": isLinkSecondary,
      "p-2 text-blue": isLinkInfo,
      "opacity-50 pointer-events-none cursor-none": disabled || isLoading,
      "rounded-full": rounded,
      "px-2 text-xs": isSizeExtraSmall,
      "px-4 text-xs": isSizeSmall,
      "px-6": isSizeMedium,
      "size-full": rounded || fullSize,
      "p-0": isSpacingNone,
      "flex flex-col items-center": isOrientationVertical
    }
  );
}

// src/action-link/index.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
function ActionLink({
  fullSize,
  orientation = "horizontal",
  rounded,
  size = "medium",
  spacing = "initial",
  variant = "primary",
  className,
  disabled,
  ...props
}) {
  return /* @__PURE__ */ jsx3(
    Link,
    {
      className: buttonStyles({
        fullSize,
        orientation,
        rounded,
        size,
        spacing,
        variant,
        className,
        disabled
      }),
      ...props
    }
  );
}

// src/app-link/index.tsx
import { Link as Link2, useParams } from "react-router-dom";
import { jsx as jsx4 } from "react/jsx-runtime";
function AppLink({ to, ...props }) {
  const { entityId: entityIdFromParams } = useParams();
  const entityIdFromStorage = localStorage.getItem("entityId");
  const entityId = entityIdFromParams || entityIdFromStorage;
  const href = entityId ? `/${entityId}${to}` : to;
  return /* @__PURE__ */ jsx4(Link2, { to: href, ...props });
}

// src/auto-complete/index.tsx
import { AutoComplete as PrimeAutoComplete } from "primereact/autocomplete";
import { useRef } from "react";

// src/float-label/index.tsx
import {
  FloatLabel as PrimeFloatLabel
} from "primereact/floatlabel";
import { jsx as jsx5 } from "react/jsx-runtime";
function FloatLabel({ invalid, ...props }) {
  return /* @__PURE__ */ jsx5(
    PrimeFloatLabel,
    {
      ...props,
      pt: {
        root: {
          className: cn(
            "[&>input:focus~label]:text-primary",
            // input focus
            "[&>input:autofill~label]:text-primary",
            // input autofill
            "[&>input.p-filled~label]:text-secondary",
            // input filled
            "[&>textarea:focus~label]:text-primary",
            // textarea focus
            "[&>.p-inputwrapper-focus~label]:text-primary",
            // autocomplete focus
            "[&>textarea.p-filled~label]:text-secondary",
            // textarea filled
            '[&>div[data-pc-name="dropdown"][data-p-focus="false"]~label]:text-secondary',
            // dropdown filled
            '[&>div[data-pc-name="dropdown"][data-p-focus="true"]~label]:text-primary',
            // dropdown focus
            "[&>input::placeholder]:text-primary",
            // placeholder
            "[&>input::placeholder:focus]:text-primary",
            // placeholder focus
            {
              "text-error": invalid,
              "[&>.p-inputwrapper-focus~label]:text-error": invalid,
              // autocomplete focus
              "[&>input:focus~label]:text-error": invalid,
              // input focus
              "[&>input:autofill~label]:text-error": invalid,
              // input autofill
              "[&>input.p-filled~label]:text-error": invalid,
              // input filled
              "[&>textarea:focus~label]:text-error": invalid,
              // textarea focus
              "[&>textarea.p-filled~label]:text-error": invalid,
              // textarea filled
              '[&>div[data-pc-name="dropdown"][data-p-focus="false"]~label]:text-error': invalid,
              // dropdown filled
              '[&>div[data-pc-name="dropdown"][data-p-focus="true"]~label]:text-error': invalid,
              // dropdown focus
              "[&>input::placeholder]:text-error": invalid,
              // placeholder
              "[&>input::placeholder:focus]:text-error": invalid
              // placeholder focus
            }
          )
        }
      }
    }
  );
}

// src/helper-text/index.tsx
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

// src/icon/index.tsx
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jsx as jsx6 } from "react/jsx-runtime";
function Icon(props) {
  return /* @__PURE__ */ jsx6(FontAwesomeIcon, { ...props });
}

// src/utils/locales/fr/index.ts
import { addLocale } from "primereact/api";
var MONDAY_NUMBER = 1;
addLocale("fr", {
  firstDayOfWeek: MONDAY_NUMBER,
  dayNames: [
    "Dimanche",
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi"
  ],
  dayNamesShort: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
  dayNamesMin: ["D", "L", "M", "MM", "J", "V", "S"],
  monthNames: [
    "Janvier",
    "F\xE9vrier",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Aout",
    "Septembre",
    "Octobre",
    "Novembre",
    "D\xE9cembre"
  ],
  monthNamesShort: [
    "jan",
    "fev",
    "mar",
    "avr",
    "mai",
    "jui",
    "jul",
    "aou",
    "sep",
    "oct",
    "nov",
    "dec"
  ],
  today: "Aujourd'hui",
  now: "Maintenant",
  clear: "R\xE9initialiser"
});

// src/helper-text/index.tsx
import { Fragment, jsx as jsx7, jsxs } from "react/jsx-runtime";
function HelperText({ error, text }) {
  return /* @__PURE__ */ jsx7(Fragment, { children: error || text ? /* @__PURE__ */ jsxs(
    "small",
    {
      className: cn(
        "flex items-center gap-1 mt-1 font-sans text-xs antialiased font-normal leading-normal",
        { "text-error": !!error }
      ),
      children: [
        error && /* @__PURE__ */ jsx7(Icon, { icon: faTriangleExclamation }),
        /* @__PURE__ */ jsx7("span", { children: error || text })
      ]
    }
  ) : null });
}

// src/auto-complete/index.tsx
import { jsx as jsx8, jsxs as jsxs2 } from "react/jsx-runtime";
function AutoComplete({
  delay = 500,
  dropdownMode = "current",
  emptyMessage = "Aucun r\xE9sultat",
  suggestions,
  error,
  helperText,
  id,
  invalid,
  maxLength = 200,
  minLength = 3,
  name,
  placeholder,
  completeMethod,
  onChange,
  onFocus,
  ref,
  ...props
}) {
  const autoCompleteRef = useRef(null);
  const connectRefs = (instance) => {
    autoCompleteRef.current = instance;
    ref?.(instance);
  };
  const handleChange = (event) => {
    onChange?.(event.value);
  };
  const handleCompleteMethod = (event) => {
    if (event.query.trim().length >= minLength && event.query.trim().length <= maxLength)
      completeMethod?.(event);
  };
  const handleFocus = (event) => {
    autoCompleteRef.current?.show();
    onFocus?.(event);
  };
  return /* @__PURE__ */ jsxs2("div", { children: [
    /* @__PURE__ */ jsxs2(FloatLabel, { invalid: !!invalid || !!error, children: [
      /* @__PURE__ */ jsx8(
        PrimeAutoComplete,
        {
          ...props,
          ref: connectRefs,
          completeMethod: handleCompleteMethod,
          delay,
          dropdownMode,
          emptyMessage,
          maxLength,
          minLength,
          suggestions,
          onChange: handleChange,
          onFocus: handleFocus,
          pt: {
            root: {
              className: "w-full"
            },
            input: {
              root: {
                className: cn(
                  "bg-white w-full border border-text-secondary/20 text-black focus:border-primary focus:shadow-inset-1 focus:!shadow-primary px-3 py-1 min-w-[150px] h-[50px] rounded-md transition-all shadow-none peer-placeholder-shown:text-primary text-sm",
                  {
                    "border-error focus:border-error focus:!shadow-error": invalid || !!error
                  }
                )
              }
            },
            item: (options) => ({
              className: cn(
                "bg-white hover:bg-primary/10 transition-all px-3 py-2",
                {
                  "bg-primary/20 text-primary": !!options?.context.selected
                }
              )
            })
          }
        }
      ),
      /* @__PURE__ */ jsx8(
        "label",
        {
          htmlFor: id ?? name,
          className: cn({ "text-error": !!invalid || !!error }),
          children: placeholder
        }
      )
    ] }),
    /* @__PURE__ */ jsx8(HelperText, { error, text: helperText })
  ] });
}

// src/badge/index.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
function Badge({
  variant,
  uppercase = true,
  ...props
}) {
  return /* @__PURE__ */ jsx9(
    "div",
    {
      "data-testid": "badge",
      className: cn("w-fit px-4 py-1 rounded-full", {
        "text-white bg-success": variant === "success",
        "text-white bg-error": variant === "error",
        "text-white bg-warning": variant === "warning",
        "text-gray-500 bg-warning/50": variant === "warning-light",
        "text-gray-500 bg-[#EAEBED]": variant === "disabled",
        "text-white bg-blue": variant === "info",
        "text-white bg-primary": variant === "primary",
        uppercase
      }),
      ...props
    }
  );
}

// src/icons/index.ts
import { faBell, faCircle, faCopy } from "@fortawesome/free-regular-svg-icons";
import {
  faAlignLeft,
  faAnglesLeft,
  faAnglesRight,
  faArrowLeft,
  faArrowRotateRight,
  faBan,
  faBars,
  faCalendarAlt,
  faCamera,
  faChartLine,
  faChartSimple,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleInfo,
  faCircleNotch,
  faCrop,
  faDownload,
  faEllipsis,
  faEnvelope,
  faEye,
  faFilter,
  faGear,
  faGlobeEurope,
  faHandshakeSimple,
  faHourglassHalf,
  faImage,
  faImages,
  faLink,
  faLocationDot,
  faMagnifyingGlass,
  faMapMarkerAlt,
  faMobile,
  faMobileScreen,
  faPaperclip,
  faPause,
  faPen,
  faPencil,
  faPenToSquare,
  faPhone,
  faPlay,
  faPlus,
  faPlusCircle,
  faQuestion,
  faQuestionCircle,
  faReply,
  faShield,
  faShieldHalved,
  faSmile,
  faTable,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashCan,
  faTriangleExclamation as faTriangleExclamation2,
  faUpload,
  faUser,
  faUserSecret,
  faVolumeHigh,
  faWarning,
  faXmark
} from "@fortawesome/free-solid-svg-icons";

// src/loading/index.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
function Loading({ centered, position = "relative" }) {
  if (centered) {
    return /* @__PURE__ */ jsx10(
      "div",
      {
        "data-testid": "loading",
        className: `flex size-full items-center justify-center ${position}`,
        children: /* @__PURE__ */ jsx10(Icon, { icon: faCircleNotch, className: "animate-spin" })
      }
    );
  }
  return /* @__PURE__ */ jsx10(Icon, { "data-testid": "loading", icon: faCircleNotch, className: "animate-spin" });
}

// src/ripple/index.tsx
import { Ripple as PrimeRipple } from "primereact/ripple";
import { jsx as jsx11 } from "react/jsx-runtime";
function Ripple({ variant = "default" }) {
  return /* @__PURE__ */ jsx11(
    PrimeRipple,
    {
      pt: {
        root: {
          style: {
            background: variant === "primary" ? "rgba(255, 255, 255, 0.3)" : "rgba(59, 192, 176, 0.3)"
          }
        }
      }
    }
  );
}

// src/button/index.tsx
import { jsx as jsx12, jsxs as jsxs3 } from "react/jsx-runtime";
function Button({
  children,
  fullSize,
  isLoading,
  orientation = "horizontal",
  rounded,
  size = "medium",
  spacing = "initial",
  variant = "primary",
  className,
  disabled,
  ...props
}) {
  return /* @__PURE__ */ jsxs3(
    "button",
    {
      ...props,
      "data-testid": "button",
      className: buttonStyles({
        className,
        disabled,
        fullSize,
        isLoading,
        orientation,
        rounded,
        size,
        spacing,
        variant
      }),
      disabled,
      children: [
        children,
        isLoading && /* @__PURE__ */ jsx12("span", { className: "ml-2", children: /* @__PURE__ */ jsx12(Loading, {}) }),
        /* @__PURE__ */ jsx12(Ripple, { variant: variant === "primary" ? variant : "default" })
      ]
    }
  );
}

// src/calendar/index.tsx
import { Calendar as PrimeCalendar } from "primereact/calendar";
import { useState } from "react";

// src/icon-button/index.tsx
import { jsx as jsx13, jsxs as jsxs4 } from "react/jsx-runtime";
function IconButton({
  iconProps,
  children,
  circle = false,
  ...props
}) {
  return /* @__PURE__ */ jsxs4(
    Button,
    {
      rounded: circle,
      ...props,
      className: cn(props.className, { "aspect-square": circle }),
      children: [
        /* @__PURE__ */ jsx13(Icon, { ...iconProps }),
        children
      ]
    }
  );
}

// src/calendar/calendar.styles.ts
function calendarStyles({ error }) {
  return {
    root: {
      className: "w-full"
    },
    input: (rootOptions) => ({
      root: {
        className: cn(
          "w-full font-sans text-base p-3 border transition-colors duration-200 appearance-none",
          {
            "border-2 border-primary": rootOptions?.props?.visible,
            "rounded-lg": !rootOptions?.props.showIcon,
            "border-r-0 rounded-l-lg": rootOptions?.props.showIcon,
            "border-error": error
          }
        )
      }
    }),
    title: {
      className: "pl-2 flex gap-x-2"
    },
    month: (rootOptions) => ({
      className: cn("transition-all hover:bg-primary/80", {
        "bg-primary text-white": rootOptions?.context.selected && !rootOptions?.context.disabled
      })
    }),
    year: (rootOptions) => ({
      className: cn("transition-all hover:bg-primary/80", {
        "bg-primary text-white": rootOptions?.context.selected && !rootOptions?.context.disabled
      })
    }),
    dayLabel: (rootOptions) => ({
      className: cn(
        "transition-all hover:bg-primary/80 p-ripple",
        {
          "opacity-60 cursor-default": rootOptions?.context.disabled,
          "cursor-pointer": !rootOptions?.context.disabled
        },
        {
          "bg-primary text-white": rootOptions?.context.selected && !rootOptions?.context.disabled
        }
      )
    }),
    buttonbar: {
      className: "px-2"
    },
    clearButton: {
      root: cn(
        "p-ripple [&>.p-ink-active]:bg-[rgba(59,192,176,0.3)]",
        buttonStyles({ variant: "secondary" })
      )
    },
    todayButton: {
      root: cn(
        "p-ripple [&>.p-ink-active]:bg-[rgba(59,192,176,0.3)]",
        buttonStyles({ variant: "secondary" })
      )
    }
  };
}

// src/calendar/calendar.utils.ts
function formatSingleCalendarValue(value2) {
  if (!value2) return null;
  return typeof value2 === "string" ? new Date(value2) : value2;
}

// src/calendar/index.tsx
import { jsx as jsx14, jsxs as jsxs5 } from "react/jsx-runtime";
function Calendar({
  error,
  helperText,
  id,
  invalid,
  locale = "fr",
  placeholder,
  showButtonBar = true,
  ref,
  value: value2,
  onChange,
  ...props
}) {
  const [visible, setVisible] = useState(false);
  const isError = !!error || !!invalid;
  const handleVisibleChange = (e) => {
    if (e.type === "outside") {
      setVisible(false);
      return;
    }
    setVisible(true);
  };
  return /* @__PURE__ */ jsxs5("div", { children: [
    /* @__PURE__ */ jsxs5(FloatLabel, { invalid: isError, children: [
      /* @__PURE__ */ jsx14(
        PrimeCalendar,
        {
          ...props,
          headerTemplate: () => /* @__PURE__ */ jsx14(
            IconButton,
            {
              iconProps: { icon: faXmark },
              variant: "secondary",
              size: "small",
              onClick: () => setVisible(false)
            }
          ),
          locale,
          pt: calendarStyles({ error: isError }),
          selectionMode: "single",
          showButtonBar,
          ref,
          value: formatSingleCalendarValue(value2),
          visible,
          onVisibleChange: handleVisibleChange,
          onChange,
          onClearButtonClick: () => setVisible(false)
        }
      ),
      /* @__PURE__ */ jsx14("label", { htmlFor: id, className: cn({ "text-error": isError }), children: placeholder })
    ] }),
    /* @__PURE__ */ jsx14(HelperText, { error, text: helperText })
  ] });
}

// src/card/index.tsx
import { Card as PrimeCard } from "primereact/card";
import { jsx as jsx15 } from "react/jsx-runtime";
function Card(props) {
  return /* @__PURE__ */ jsx15(PrimeCard, { ...props, pt: { content: { className: "py-0" } } });
}

// src/chart/index.tsx
import { Chart as PrimeChart } from "primereact/chart";
import { jsx as jsx16 } from "react/jsx-runtime";
function Chart({ ...props }) {
  return /* @__PURE__ */ jsx16(PrimeChart, { ...props });
}

// src/chip/index.tsx
import { jsx as jsx17, jsxs as jsxs6 } from "react/jsx-runtime";
function Chip({
  children,
  leftIcon,
  clearable = true,
  disabled = false,
  onClear,
  onClick
}) {
  return /* @__PURE__ */ jsxs6(
    "div",
    {
      "data-testid": "badge",
      className: cn(
        "flex items-center w-fit gap-2 px-1.5 h-8 rounded-full bg-[#E1E2E8] text-xs md:text-sm text-text-secondary",
        // Align design when no "times" icon is shown.
        { "pr-2": !clearable }
      ),
      role: onClick ? "button" : void 0,
      tabIndex: onClick ? 0 : void 0,
      onClick,
      children: [
        leftIcon && /* @__PURE__ */ jsx17(
          Icon,
          {
            icon: leftIcon,
            className: "size-4 pl-1 text-[#7D7B83] md:size-6"
          }
        ),
        children,
        clearable && /* @__PURE__ */ jsx17(
          Icon,
          {
            icon: faTimesCircle,
            className: cn("text-[#B6B5BC] size-4 md:size-6", {
              "opacity-25 pointer-events-none": disabled,
              "hover:opacity-80 transition-all": !disabled
            }),
            role: "button",
            tabIndex: 0,
            "aria-disabled": disabled,
            onClick: (event) => {
              event.stopPropagation();
              onClear?.();
            }
          }
        )
      ]
    }
  );
}

// src/color-picker/index.tsx
import { jsx as jsx18, jsxs as jsxs7 } from "react/jsx-runtime";
function ColorPicker({
  disabled,
  error,
  helperText,
  label,
  ref,
  value: value2,
  onBlur,
  onChange
}) {
  return /* @__PURE__ */ jsx18("div", { className: "relative w-full min-w-[200px]", children: /* @__PURE__ */ jsxs7("div", { className: "relative h-[50px] w-full", children: [
    /* @__PURE__ */ jsx18(
      "input",
      {
        ref,
        type: "color",
        value: value2,
        onBlur,
        onChange,
        className: cn(
          "peer size-full rounded-md border border-t-0 bg-white px-3 py-2.5 font-sans text-sm font-normal outline outline-0 transition-all placeholder-shown:border focus:border-2 focus:border-t-0 focus:border-t-transparent focus:outline-0 border-text-secondary/20 focus:border-primary ",
          {
            "border-error placeholder-shown:border-error focus:border-error": error
          }
        ),
        disabled
      }
    ),
    /* @__PURE__ */ jsx18(
      "label",
      {
        className: cn(
          "before:content[' '] after:content[' '] pointer-events-none absolute top-[-7px] flex size-full select-none !overflow-visible truncate text-[11px] font-normal leading-tight text-secondary transition-all before:pointer-events-none before:mr-1 before:mt-[6.5px] before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-l before:border-t before:border-text-secondary/20 before:transition-all after:pointer-events-none after:ml-1 after:mt-[6.5px] after:box-border after:block after:h-1.5 after:w-2.5 after:grow after:rounded-tr-md after:border-r after:border-t after:border-text-secondary/20 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-primary peer-focus:before:border-l peer-focus:before:border-t-2 peer-focus:before:border-primary peer-focus:after:border-r peer-focus:after:border-t-2 peer-focus:after:border-primary",
          {
            "text-error before:border-error after:border-error peer-placeholder-shown:text-error peer-focus:text-error peer-focus:before:border-error peer-focus:after:border-error": error
          }
        ),
        children: label
      }
    ),
    /* @__PURE__ */ jsx18(HelperText, { error, text: helperText })
  ] }) });
}

// src/confirm-dialog/index.tsx
import {
  ConfirmDialog as PrimeConfirmDialog
} from "primereact/confirmdialog";
import { jsx as jsx19 } from "react/jsx-runtime";
function ConfirmDialog({
  header = "Confirmez votre choix",
  acceptLabel = "Confirmer",
  rejectLabel = "Annuler",
  ...props
}) {
  return /* @__PURE__ */ jsx19(
    PrimeConfirmDialog,
    {
      ...props,
      icon: /* @__PURE__ */ jsx19(Icon, { icon: faTriangleExclamation2, size: "2xl" }),
      header,
      acceptLabel,
      rejectLabel,
      defaultFocus: "reject",
      pt: {
        footer: {
          className: "flex items-end justify-end gap-x-4"
        },
        acceptButton: {
          root: {
            className: buttonStyles({ variant: "primary" })
          }
        },
        rejectButton: {
          root: {
            className: buttonStyles({ variant: "secondary" })
          }
        }
      }
    }
  );
}

// src/confirm-dialog-fn/index.tsx
import { confirmDialog } from "primereact/confirmdialog";
function confirmDialogFn(props) {
  return confirmDialog(props);
}

// src/contexts/stepper-context/index.tsx
import { createContext, useContext } from "react";
var StepperContext = createContext({
  activeStep: 0,
  prevStep: () => null,
  nextStep: () => null,
  goToStep: () => Promise.resolve(),
  triggerStepper: () => null
});
function useStepperContext() {
  return useContext(StepperContext);
}

// src/contexts/toast-context/index.tsx
import { createContext as createContext2, useContext as useContext2 } from "react";
var ToastContext = createContext2({
  showMessage: () => null,
  clear: () => null
});
function useToastContext() {
  return useContext2(ToastContext);
}

// src/custom-icon/components/ai-brain/index.tsx
import { jsx as jsx20, jsxs as jsxs8 } from "react/jsx-runtime";
function AiBrain(props) {
  return /* @__PURE__ */ jsxs8(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M15.1505 10.8288C15.1505 10.2839 14.7669 9.79267 14.2076 9.60982C14.2183 9.55604 14.2219 9.50226 14.2219 9.44848C14.2219 8.88917 13.7271 8.43384 13.1212 8.43384C12.8308 8.43384 12.5512 8.5414 12.3468 8.72783C12.1424 8.5414 11.8628 8.43384 11.5724 8.43384C10.9665 8.43384 10.4717 8.88917 10.4717 9.44848C10.4717 9.50226 10.4753 9.55604 10.486 9.60982C9.92672 9.78908 9.54309 10.2839 9.54309 10.8288C9.54309 11.0941 9.62914 11.3487 9.79765 11.5638C9.63272 11.7968 9.54309 12.0657 9.54309 12.3418C9.54309 12.7864 9.77255 13.2095 10.1633 13.4784C10.1849 14.0986 10.7406 14.5934 11.4182 14.5934C11.7731 14.5934 12.1102 14.4571 12.3468 14.2133C12.5834 14.4536 12.9204 14.5934 13.2754 14.5934C13.9243 14.5934 14.4657 14.138 14.5267 13.5501C14.9139 13.3134 15.1505 12.9047 15.1505 12.4781C15.1505 12.1769 15.0322 11.8829 14.8207 11.6534C15.0322 11.4204 15.1505 11.13 15.1505 10.8288ZM13.2718 12.5677C13.2467 12.6501 13.2539 12.7398 13.2933 12.8151C13.3328 12.894 13.4009 12.9477 13.4833 12.9764C13.7164 13.0517 13.8741 13.2381 13.8741 13.4425C13.8741 13.7186 13.6052 13.9409 13.2718 13.9409C12.9384 13.9409 12.6695 13.715 12.6695 13.4425V11.7897C12.6695 11.5136 12.9384 11.2913 13.2718 11.2913C13.4511 11.2913 13.5981 11.1443 13.5981 10.9651C13.5981 10.7858 13.4511 10.6388 13.2718 10.6388C13.0603 10.6388 12.8523 10.689 12.6695 10.7822V10.5707C12.6695 10.3914 12.5225 10.2444 12.3432 10.2444C12.1639 10.2444 12.0169 10.3914 12.0169 10.5707V11.8829C11.9524 11.8506 11.8879 11.8255 11.8233 11.804C11.6512 11.7502 11.4684 11.847 11.4146 12.0191C11.3895 12.1016 11.3967 12.1912 11.4361 12.2665C11.4756 12.3454 11.5437 12.3992 11.6261 12.4279C11.8592 12.5032 12.0169 12.6896 12.0169 12.8939V13.4461C12.0169 13.7222 11.748 13.9444 11.4146 13.9444C11.0812 13.9444 10.8123 13.7186 10.8123 13.4461C10.8123 13.3314 10.8625 13.2166 10.9521 13.127C11.0131 13.066 11.0489 12.9836 11.0489 12.8975C11.0489 12.8115 11.0166 12.729 10.9557 12.6681C10.8947 12.6071 10.8123 12.5713 10.7262 12.5713C10.6402 12.5713 10.5577 12.6035 10.4968 12.6645C10.4538 12.7075 10.4143 12.7541 10.3785 12.8043C10.2637 12.6717 10.1992 12.5103 10.1992 12.3454C10.1992 11.9976 10.4753 11.6893 10.8732 11.5961C10.9593 11.5781 11.031 11.5244 11.0776 11.4527C11.1242 11.3774 11.1385 11.2913 11.1206 11.2053C11.1027 11.1192 11.0489 11.0475 10.9772 11.0009C10.9019 10.9543 10.8159 10.94 10.7298 10.9579C10.5757 10.9937 10.4287 11.0511 10.2924 11.1264C10.2315 11.0332 10.2028 10.9328 10.2028 10.8288C10.2028 10.481 10.5398 10.1942 10.9521 10.1906C10.9557 10.1906 10.9593 10.1906 10.9629 10.1906C11.0382 10.1906 11.1135 10.162 11.1744 10.1118C11.2963 10.0078 11.325 9.82852 11.2389 9.68869C11.2354 9.68511 11.2354 9.68152 11.2318 9.67794C11.2318 9.67435 11.2282 9.67435 11.2282 9.67077C11.2246 9.6636 11.2174 9.66001 11.2138 9.65284L11.2067 9.64567C11.1708 9.60265 11.1314 9.53452 11.1314 9.44489C11.1314 9.24412 11.3322 9.08278 11.5795 9.08278C11.8269 9.08278 12.0277 9.24412 12.0277 9.44489C12.0277 9.62416 12.1747 9.77115 12.354 9.77115C12.5332 9.77115 12.6802 9.62416 12.6802 9.44489C12.6802 9.24412 12.881 9.08278 13.1284 9.08278C13.3758 9.08278 13.5766 9.24412 13.5766 9.44489C13.5766 9.47716 13.5694 9.50943 13.5586 9.5417C13.4188 9.55962 13.2826 9.59547 13.1571 9.64925C13.0782 9.68152 13.0137 9.74606 12.9814 9.82852C12.9491 9.91098 12.9491 9.99703 12.9814 10.0795C13.0137 10.1584 13.0782 10.2229 13.1607 10.2552C13.2431 10.2874 13.3292 10.2874 13.4116 10.2552C13.5156 10.2121 13.6267 10.1906 13.7415 10.187C13.7486 10.187 13.7558 10.187 13.7558 10.187C14.1717 10.1906 14.5087 10.4775 14.5087 10.8252C14.5087 11.0439 14.3725 11.2447 14.1502 11.363C14.0426 11.4204 13.9745 11.5315 13.9745 11.6534C13.9745 11.7753 14.0426 11.8865 14.1502 11.9438C14.3761 12.0622 14.5087 12.2629 14.5087 12.4816C14.5087 12.6143 14.4585 12.7434 14.3653 12.8545C14.2147 12.6215 13.9781 12.4458 13.6949 12.3562C13.5084 12.2988 13.3256 12.3956 13.2718 12.5677Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M17.3089 18.214C17.1082 18.214 16.9217 18.257 16.7496 18.3323L15.3908 16.9735C15.3119 16.8946 15.2689 16.7906 15.2689 16.6795V16.0556H15.3729C15.5019 16.0556 15.6274 16.0413 15.7493 16.009C15.968 15.9516 16.1007 15.7258 16.0469 15.5071C15.9895 15.2884 15.7637 15.1557 15.545 15.2095C15.4876 15.2238 15.4302 15.231 15.3729 15.231H9.31371C8.93367 15.231 8.62533 14.9227 8.62533 14.5426V8.48705C8.62533 8.42969 8.63251 8.36874 8.64685 8.31496C8.67553 8.2074 8.6576 8.09626 8.60382 8.00304C8.54646 7.90982 8.45683 7.8417 8.35285 7.81302C8.24529 7.78434 8.13415 7.80226 8.04093 7.85604C7.94771 7.91341 7.87959 8.00304 7.85091 8.10701C7.81864 8.22891 7.8043 8.35798 7.8043 8.48347V8.6233H6.28772C6.12638 8.03172 5.585 7.5979 4.94682 7.5979C4.17956 7.5979 3.55572 8.22174 3.55572 8.989C3.55572 9.75625 4.17956 10.3801 4.94682 10.3801C5.55273 10.3801 6.06902 9.9893 6.25904 9.44792H7.80789V9.86381H6.84344C6.61757 9.86381 6.43113 10.0502 6.43113 10.2761C6.43113 10.502 6.61757 10.6884 6.84344 10.6884H7.80789V11.1043H3.80669C3.58082 11.1043 3.39438 11.2908 3.39438 11.5166C3.39438 11.7425 3.58082 11.9289 3.80669 11.9289H7.80072V12.3448H6.83627C6.6104 12.3448 6.42396 12.5313 6.42396 12.7571C6.42396 12.983 6.6104 13.1695 6.83627 13.1695H7.80072V13.5854H7.17687C6.84703 13.5854 6.53511 13.7144 6.30206 13.9475L5.07947 15.1701C4.87511 15.0553 4.64207 14.9872 4.3911 14.9872C3.62384 14.9872 3 15.611 3 16.3783C3 17.1456 3.62384 17.7694 4.3911 17.7694C5.15835 17.7694 5.78219 17.1456 5.78219 16.3783C5.78219 16.1596 5.732 15.9552 5.64237 15.7724L6.88646 14.5283C6.96534 14.4494 7.06931 14.4064 7.18046 14.4064H7.8043V14.5462C7.8043 15.3816 8.48192 16.0592 9.3173 16.0592H9.45712V17.7586C8.88348 17.9307 8.464 18.4614 8.464 19.0924C8.464 19.8596 9.08784 20.4835 9.85509 20.4835C10.6223 20.4835 11.2462 19.8596 11.2462 19.0924C11.2462 18.4721 10.8411 17.9487 10.2782 17.7694V16.0628H10.6941V17.0272C10.6941 17.2531 10.8805 17.4395 11.1064 17.4395C11.3322 17.4395 11.5187 17.2531 11.5187 17.0272V16.0628H11.9346V20.0568C11.9346 20.2827 12.121 20.4691 12.3469 20.4691C12.5728 20.4691 12.7592 20.2827 12.7592 20.0568V16.0592H13.2073V17.0237C13.2073 17.2495 13.3938 17.436 13.6197 17.436C13.8455 17.436 14.032 17.2495 14.032 17.0237V16.0592H14.4443V16.683C14.4443 17.0129 14.5733 17.3248 14.8064 17.5579L16.1258 18.8773C15.9931 19.0888 15.9178 19.3398 15.9178 19.6087C15.9178 20.3759 16.5417 20.9997 17.3089 20.9997C18.0762 20.9997 18.7 20.3759 18.7 19.6087C18.7 18.8414 18.0762 18.214 17.3089 18.214ZM4.93965 9.55547C4.62773 9.55547 4.37317 9.30092 4.37317 8.989C4.37317 8.67708 4.62773 8.42252 4.93965 8.42252C5.25157 8.42252 5.50612 8.67708 5.50612 8.989C5.50612 9.3045 5.25157 9.55547 4.93965 9.55547ZM4.3911 16.9448C4.07918 16.9448 3.82462 16.6902 3.82462 16.3783C3.82462 16.0664 4.07918 15.8118 4.3911 15.8118C4.70302 15.8118 4.95757 16.0664 4.95757 16.3783C4.95757 16.6902 4.70302 16.9448 4.3911 16.9448ZM9.85509 19.6588C9.54317 19.6588 9.28862 19.4043 9.28862 19.0924C9.28862 18.7804 9.54317 18.5259 9.85509 18.5259C10.167 18.5259 10.4216 18.7804 10.4216 19.0924C10.4216 19.4043 10.167 19.6588 9.85509 19.6588ZM17.3089 20.1715C16.997 20.1715 16.7425 19.917 16.7425 19.6051C16.7425 19.2931 16.997 19.0386 17.3089 19.0386C17.6209 19.0386 17.8754 19.2931 17.8754 19.6051C17.8754 19.917 17.6209 20.1715 17.3089 20.1715Z",
            fill: "currentcolor"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M20.8799 11.911C21.0986 11.911 21.2743 11.7353 21.2743 11.5166C21.2743 11.2979 21.0986 11.1223 20.8799 11.1223H16.8716V10.6741H17.8504C18.0691 10.6741 18.2447 10.4984 18.2447 10.2797C18.2447 10.061 18.0691 9.88533 17.8504 9.88533H16.868V9.43717H17.5062C17.8324 9.43717 18.1408 9.31168 18.3702 9.07864L19.6107 7.83812C19.7972 7.93134 20.0051 7.98154 20.2238 7.98154C20.9911 7.98154 21.6149 7.35769 21.6149 6.59044C21.6149 5.82319 20.9911 5.19934 20.2238 5.19934C19.4566 5.19934 18.8327 5.82319 18.8327 6.59044C18.8327 6.84858 18.9044 7.09238 19.0299 7.30033L17.8109 8.51933C17.7285 8.60179 17.6209 8.64482 17.5062 8.64482H16.868V8.48706C16.868 7.66244 16.1975 6.99199 15.3729 6.99199H15.2152V5.34993C15.796 5.185 16.2226 4.64721 16.2226 4.01261C16.2226 3.24536 15.5988 2.62151 14.8315 2.62151C14.0643 2.62151 13.4404 3.24536 13.4404 4.01261C13.4404 4.63645 13.8563 5.16708 14.4228 5.34276V6.99199H13.9782V6.00962C13.9782 5.79092 13.8026 5.61524 13.5838 5.61524C13.3651 5.61524 13.1895 5.79092 13.1895 6.00962V6.99199H12.7413V2.98004C12.7413 2.76134 12.5656 2.58566 12.3469 2.58566C12.1282 2.58566 11.9525 2.76134 11.9525 2.98004V6.99199H11.5044V6.00962C11.5044 5.79092 11.3287 5.61524 11.11 5.61524C10.8913 5.61524 10.7156 5.79092 10.7156 6.00962V6.99199H10.2997V6.35381C10.2997 6.02755 10.1742 5.71921 9.94118 5.48975L8.62538 4.17395C8.76162 3.95883 8.84408 3.70069 8.84408 3.42821C8.84408 2.66095 8.22024 2.03711 7.45299 2.03711C6.68573 2.03711 6.06189 2.66095 6.06189 3.42821C6.06189 4.19546 6.68573 4.8193 7.45299 4.8193C7.65735 4.8193 7.85454 4.77269 8.03022 4.69382L9.38546 6.04906C9.46792 6.13152 9.51095 6.23908 9.51095 6.35381V6.99199H9.32093C9.19544 6.99199 9.06996 7.00633 8.94806 7.0386C8.84767 7.0637 8.76162 7.12823 8.70784 7.22145C8.65406 7.31108 8.63972 7.41864 8.66482 7.51903C8.68991 7.62301 8.75445 7.70547 8.84767 7.75925C8.9373 7.81303 9.04486 7.82737 9.14883 7.80227C9.2062 7.78793 9.26715 7.78076 9.32451 7.78076H15.3837C15.7745 7.78076 16.09 8.09627 16.09 8.48706V14.5462C16.09 14.6072 16.0828 14.6645 16.0685 14.7219C16.0147 14.9334 16.1402 15.1485 16.3517 15.2023C16.384 15.2095 16.4162 15.2131 16.4485 15.2131C16.6278 15.2131 16.7855 15.0912 16.8321 14.9155C16.8644 14.7936 16.8787 14.6681 16.8787 14.5426V14.3849H18.5674C18.7754 14.894 19.2737 15.2561 19.8581 15.2561C20.6254 15.2561 21.2492 14.6323 21.2492 13.865C21.2492 13.0978 20.6254 12.4739 19.8581 12.4739C19.1841 12.4739 18.6212 12.9579 18.4921 13.5961H16.8752V13.148H17.8504C18.0691 13.148 18.2447 12.9723 18.2447 12.7536C18.2447 12.5349 18.0691 12.3592 17.8504 12.3592H16.868V11.911H20.8799ZM20.2274 6.02038C20.5393 6.02038 20.7939 6.27493 20.7939 6.58685C20.7939 6.89878 20.5393 7.15333 20.2274 7.15333C19.9155 7.15333 19.6609 6.89878 19.6609 6.58685C19.6609 6.27135 19.9155 6.02038 20.2274 6.02038ZM6.88292 3.42462C6.88292 3.1127 7.13748 2.85814 7.4494 2.85814C7.76132 2.85814 8.01588 3.1127 8.01588 3.42462C8.01588 3.73654 7.76132 3.9911 7.4494 3.9911C7.13748 3.9911 6.88292 3.73654 6.88292 3.42462ZM14.8351 3.44255C15.147 3.44255 15.4016 3.6971 15.4016 4.00902C15.4016 4.32095 15.147 4.5755 14.8351 4.5755C14.5232 4.5755 14.2686 4.32095 14.2686 4.00902C14.2686 3.6971 14.5232 3.44255 14.8351 3.44255ZM19.851 13.3021C20.1629 13.3021 20.4174 13.5567 20.4174 13.8686C20.4174 14.1805 20.1629 14.4351 19.851 14.4351C19.539 14.4351 19.2845 14.1805 19.2845 13.8686C19.2845 13.5567 19.539 13.3021 19.851 13.3021Z",
            fill: "currentcolor"
          }
        )
      ]
    }
  );
}

// src/custom-icon/components/increase/index.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
function Increase(props) {
  return /* @__PURE__ */ jsx21(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx21(
        "path",
        {
          d: "M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z",
          fill: "currentcolor"
        }
      )
    }
  );
}

// src/custom-icon/components/menu/index.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
function Menu(props) {
  return /* @__PURE__ */ jsx22(
    "svg",
    {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx22(
        "path",
        {
          d: "M3.3335 13H5.3335V11H3.3335V13ZM3.3335 17H5.3335V15H3.3335V17ZM3.3335 9H5.3335V7H3.3335V9ZM7.3335 13H21.3335V11H7.3335V13ZM7.3335 17H21.3335V15H7.3335V17ZM7.3335 7V9H21.3335V7H7.3335Z",
          fill: "currentcolor"
        }
      )
    }
  );
}

// src/custom-icon/components/thumbs-down/index.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
function ThumbsDown(props) {
  return /* @__PURE__ */ jsx23(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx23(
        "path",
        {
          d: "M22 4H20C19.45 4 19 4.45 19 5V14C19 14.55 19.45 15 20 15H22V4ZM2.17 11.12C2.06 11.37 2 11.64 2 11.92V13C2 14.1 2.9 15 4 15H9.5L8.58 19.65C8.53 19.87 8.56 20.11 8.66 20.31C8.89 20.76 9.18 21.17 9.54 21.53L10 22L16.41 15.59C16.79 15.21 17 14.7 17 14.17V6.34C17 5.05 15.95 4 14.66 4H6.56C5.85 4 5.2 4.37 4.84 4.97L2.17 11.12Z",
          fill: "currentcolor",
          fillOpacity: "0.54"
        }
      )
    }
  );
}

// src/custom-icon/components/thumbs-up/index.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
function ThumbsUp(props) {
  return /* @__PURE__ */ jsx24(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx24(
        "path",
        {
          d: "M2 20H4C4.55 20 5 19.55 5 19V10C5 9.45 4.55 9 4 9H2V20ZM21.83 12.88C21.94 12.63 22 12.36 22 12.08V11C22 9.9 21.1 9 20 9H14.5L15.42 4.35C15.47 4.13 15.44 3.89 15.34 3.69C15.11 3.24 14.82 2.83 14.46 2.47L14 2L7.59 8.41C7.21 8.79 7 9.3 7 9.83V17.67C7 18.95 8.05 20 9.34 20H17.45C18.15 20 18.81 19.63 19.17 19.03L21.83 12.88Z",
          fill: "currentcolor",
          fillOpacity: "0.54"
        }
      )
    }
  );
}

// src/custom-icon/components/thumbs-up-down/index.tsx
import { jsx as jsx25, jsxs as jsxs9 } from "react/jsx-runtime";
function ThumbsUpDown(props) {
  return /* @__PURE__ */ jsxs9(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx25("g", { clipPath: "url(#clip0_1192_1055)", children: /* @__PURE__ */ jsx25(
          "path",
          {
            d: "M12 6C12 5.45 11.55 5 11 5H5.82L6.48 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 0.79L5.38 0L0.44 4.94C0.17 5.21 0 5.59 0 6V12.5C0 13.33 0.67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6ZM22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.52 22.18L17.5 22.42C17.5 22.73 17.63 23.01 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10Z",
            fill: "currentcolor",
            fillOpacity: "0.54"
          }
        ) }),
        /* @__PURE__ */ jsx25("defs", { children: /* @__PURE__ */ jsx25("clipPath", { id: "clip0_1192_1055", children: /* @__PURE__ */ jsx25("rect", { width: "24", height: "24", fill: "white" }) }) })
      ]
    }
  );
}

// src/custom-icon/components/thumbs-up-outline/index.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
function ThumbsUpOutline(props) {
  return /* @__PURE__ */ jsx26(
    "svg",
    {
      width: "25",
      height: "24",
      viewBox: "0 0 25 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx26(
        "path",
        {
          d: "M13.7765 5.72L13.2065 8.61C13.0865 9.2 13.2465 9.81 13.6265 10.27C14.0065 10.73 14.5665 11 15.1665 11H20.6665V12.08L18.0965 18H10.0065C9.8265 18 9.6665 17.84 9.6665 17.66V9.82L13.7765 5.72ZM14.6665 2L8.2565 8.41C7.8765 8.79 7.6665 9.3 7.6665 9.83V17.66C7.6665 18.95 8.7165 20 10.0065 20H18.1065C18.8165 20 19.4665 19.63 19.8265 19.03L22.4965 12.88C22.6065 12.63 22.6665 12.36 22.6665 12.08V11C22.6665 9.9 21.7665 9 20.6665 9H15.1665L16.0865 4.35C16.1365 4.13 16.1065 3.89 16.0065 3.69C15.7765 3.24 15.4865 2.83 15.1265 2.47L14.6665 2ZM4.6665 9H2.6665V20H4.6665C5.2165 20 5.6665 19.55 5.6665 19V10C5.6665 9.45 5.2165 9 4.6665 9Z",
          fill: "currentcolor"
        }
      )
    }
  );
}

// src/custom-icon/components/times-hexagon/index.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
function TimesHexagon(props) {
  return /* @__PURE__ */ jsx27(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: /* @__PURE__ */ jsx27(
        "path",
        {
          d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM17 15.74L15.74 17L12 13.26L8.26 17L7 15.74L10.74 12L7 8.26L8.26 7L12 10.74L15.74 7L17 8.26L13.26 12L17 15.74Z",
          fill: "currentcolor",
          fillOpacity: "0.54"
        }
      )
    }
  );
}

// src/custom-icon/custom-icon.config.ts
var ICONS = {
  THUMBS_UP: ThumbsUp,
  THUMBS_UP_OUTLINE: ThumbsUpOutline,
  THUMBS_DONW: ThumbsDown,
  THUMBS_UP_DONW: ThumbsUpDown,
  TIMES_HEXAGON: TimesHexagon,
  MENU: Menu,
  INCREASE: Increase,
  AI_BRAIN: AiBrain
};

// src/custom-icon/index.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
function CustomIcon({ name, ...props }) {
  const Icon2 = ICONS[name];
  return /* @__PURE__ */ jsx28(Icon2, { ...props });
}

// src/dialog/index.tsx
import { Dialog as PrimeDialog } from "primereact/dialog";
import { jsx as jsx29 } from "react/jsx-runtime";
function Dialog({ size = "w-[75vw]", ...props }) {
  return /* @__PURE__ */ jsx29(
    PrimeDialog,
    {
      "data-testid": "dialog",
      draggable: false,
      ...props,
      pt: {
        root: {
          className: cn("bg-white p-4 rounded-lg shadow", size)
        },
        header: { className: "text-xl" },
        mask: { className: "bg-black/50" }
      }
    }
  );
}

// src/file-uploader/hooks/use-file-uploader.ts
import { useCallback, useRef as useRef2, useState as useState2 } from "react";
var readAsDataURL = function(file, acceptedFiles, maxSize, onReadDataUrl, onError) {
  const reader = new FileReader();
  reader.onloadend = (e) => {
    if (!e.target) {
      onError?.("reader event target is unvailable");
      return;
    }
    if (!e.target.result) {
      onError?.("event target result is unvailable");
      return;
    }
    if (typeof e.target.result !== "string") {
      onError?.("event target result is not a URL source file");
      return;
    }
    const { name, size } = file;
    if (size > maxSize) {
      onError?.("The file is too large");
      return;
    }
    const extension = name?.split?.(".").pop();
    const acceptedExtensions = acceptedFiles.split(",");
    if (!name || !extension || !acceptedExtensions.find(
      (acceptedExtension) => `.${extension.toLowerCase()}` === acceptedExtension.toLowerCase()
    )) {
      onError?.("Le format de ce fichier n'est pas autoris\xE9");
      return;
    }
    onReadDataUrl(e.target.result);
  };
  reader.readAsDataURL(file);
};
function useFileUploader({
  value: value2,
  acceptedFiles,
  maxSize,
  onChange
}) {
  const inputRef = useRef2(null);
  const [isLoading, setIsLoading] = useState2(false);
  const [uploadError, setUploadError] = useState2();
  const handleChange = useCallback(
    async (e) => {
      const [file] = e.target.files ?? [];
      if (!file) return;
      setIsLoading(true);
      readAsDataURL(
        file,
        acceptedFiles,
        maxSize,
        (src) => {
          const { name, size } = file;
          const extension = name?.split?.(".").pop();
          onChange?.({ src, name, size, extension });
          setIsLoading(false);
        },
        (reason) => {
          setUploadError(reason);
          setIsLoading(false);
        }
      );
    },
    [acceptedFiles, maxSize, onChange]
  );
  const handleFileLoad = () => {
    onChange?.({ ...value2 });
  };
  const handleRemove = useCallback(() => {
    if (inputRef.current) inputRef.current.value = "";
    onChange?.({ src: "", name: "", size: 0, extension: "" });
  }, [inputRef, onChange]);
  return {
    isLoading,
    inputRef,
    uploadError,
    handleChange,
    handleFileLoad,
    handleRemove
  };
}

// src/file-uploader/file-uploader.tsx
import { Fragment as Fragment2, jsx as jsx30, jsxs as jsxs10 } from "react/jsx-runtime";
function FileUploader({
  disabled,
  error,
  helperText,
  name,
  placeholder,
  value: value2,
  acceptedFiles = "",
  maxSize = 1e8,
  onChange
}) {
  const { isLoading, inputRef, handleChange, handleRemove, uploadError } = useFileUploader({
    value: value2,
    acceptedFiles,
    maxSize,
    onChange
  });
  return /* @__PURE__ */ jsxs10("div", { className: "relative w-full min-w-[200px]", children: [
    /* @__PURE__ */ jsxs10(
      "div",
      {
        className: cn(
          "grid border w-full h-[60px] rounded-md border-t-0 relative p-1",
          { "border-error": error || uploadError },
          { "border-text-secondary/20": !error && !uploadError }
        ),
        children: [
          /* @__PURE__ */ jsxs10("div", { className: "relative flex size-full items-center justify-center overflow-hidden rounded-md", children: [
            !!value2?.name && /* @__PURE__ */ jsxs10("div", { className: "flex w-full items-center", children: [
              /* @__PURE__ */ jsx30("div", { className: "flex size-8 flex-none items-center justify-center rounded-full bg-primary", children: /* @__PURE__ */ jsx30(Icon, { icon: faPaperclip, className: "m-auto text-white" }) }),
              /* @__PURE__ */ jsx30("div", { className: "flex flex-initial flex-col gap-y-2 p-2 text-sm", children: /* @__PURE__ */ jsx30("p", { className: "font-bold", children: value2.name }) })
            ] }),
            isLoading && /* @__PURE__ */ jsx30(Loading, { position: "absolute", centered: true })
          ] }),
          /* @__PURE__ */ jsx30("div", { className: "absolute right-3 top-2 flex gap-x-2", children: !disabled && /* @__PURE__ */ jsxs10(Fragment2, { children: [
            /* @__PURE__ */ jsxs10(
              "label",
              {
                htmlFor: name,
                className: "p-ripple cursor-pointer rounded-lg bg-primary px-4 py-2 text-xs text-white shadow-md transition-all hover:bg-primary/80",
                children: [
                  /* @__PURE__ */ jsx30(Icon, { icon: faPencil, role: "button", id: `${name}-update` }),
                  /* @__PURE__ */ jsx30(Ripple, { variant: "primary" })
                ]
              }
            ),
            /* @__PURE__ */ jsx30(
              "input",
              {
                type: "file",
                id: name,
                accept: acceptedFiles,
                className: "hidden",
                onChange: handleChange,
                ref: inputRef
              }
            ),
            value2?.src && /* @__PURE__ */ jsx30(
              IconButton,
              {
                name: `${name}-delete-file`,
                size: "small",
                type: "button",
                iconProps: {
                  icon: faTrashCan
                },
                onClick: handleRemove
              }
            )
          ] }) })
        ]
      }
    ),
    /* @__PURE__ */ jsx30(
      "label",
      {
        className: cn(
          "before:content[' '] after:content[' '] pointer-events-none absolute top-[-7px] flex size-full select-none !overflow-visible truncate text-[11px] font-normal leading-tight text-secondary transition-all before:pointer-events-none before:mr-1 before:mt-[6.5px] before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-l before:border-t before:border-text-secondary/20 before:transition-all after:pointer-events-none after:ml-1 after:mt-[6.5px] after:box-border after:block after:h-1.5 after:w-2.5 after:grow after:rounded-tr-md after:border-r after:border-t after:border-text-secondary/20 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-secondary peer-focus:before:border-l peer-focus:before:border-t peer-focus:before:border-text-secondary/20 peer-focus:after:border-r peer-focus:after:border-t peer-focus:after:border-text-secondary/20 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent",
          {
            "text-error before:border-error after:border-error peer-focus:text-error peer-focus:before:!border-error peer-focus:after:!border-error": error || uploadError
          }
        ),
        children: placeholder
      }
    ),
    /* @__PURE__ */ jsx30(HelperText, { error: error || uploadError, text: helperText })
  ] });
}

// src/heading-1/index.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
function Heading1({ withOpacity, className, ...props }) {
  return /* @__PURE__ */ jsx31(
    "h1",
    {
      "data-testid": "heading-1",
      className: cn("text-xl", className, { "opacity-65": withOpacity }),
      ...props
    }
  );
}

// src/heading-2/index.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
function Heading2({ withOpacity, className, ...props }) {
  return /* @__PURE__ */ jsx32(
    "h2",
    {
      "data-testid": "heading-2",
      className: cn("text-sm font-semibold", className, {
        "opacity-65": withOpacity
      }),
      ...props
    }
  );
}

// src/hooks/use-emoji-picker-text/index.ts
import { useRef as useRef3 } from "react";
function useEmojiPickerText({ onChange }) {
  const textRef = useRef3(null);
  const insertEmoji = (emojiData) => {
    const emoji = emojiData.emoji;
    const textarea = textRef.current;
    if (!textarea) return;
    const start = textarea.selectionStart ?? 0;
    const newText = textRef.current?.value.slice(0, start) + emoji + textRef.current?.value.slice(start);
    const event = {
      target: { value: newText }
    };
    new Promise((resolve) => resolve(onChange?.(event))).then(() => {
      const newCursorPosition = start + emoji.length;
      textarea.focus();
      textarea.setSelectionRange(newCursorPosition, newCursorPosition);
    });
  };
  return {
    textRef,
    insertEmoji
  };
}

// src/hooks/use-horizontal-scrollbar/index.ts
import { useCallback as useCallback2 } from "react";
function useHorizontalScrollbar(wheelSpeed = 0.75) {
  const ref = useCallback2((node) => {
    if (!node) return;
    node.className = cn(
      node.className,
      "overflow-x-auto overflow-y-hidden overscroll-none no-scrollbar"
    );
  }, []);
  const onWheel = (event) => {
    const element = event.currentTarget;
    const offset = event.deltaY * wheelSpeed;
    const newScrollLeft = element.scrollLeft + offset - element.clientLeft;
    element.scrollTo({
      left: newScrollLeft,
      behavior: "auto"
    });
    event.stopPropagation();
  };
  return {
    ref,
    onWheel
  };
}

// src/hooks/use-stepper-handle/index.ts
import { useImperativeHandle } from "react";
function useStepperHandle({ onChangeStep }) {
  const { stepperRef } = useStepperContext();
  useImperativeHandle(stepperRef, () => ({
    onChangeStep
  }));
}

// src/hooks/use-table-pagination/index.ts
import { useCallback as useCallback3, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
var DEFAULTS = {
  PAGE: "1",
  ROWS: "10"
};
var useTablePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams({
    ["pageNumber" /* PAGE_NUMBER */]: DEFAULTS.PAGE,
    ["pageSize" /* PAGE_SIZE */]: DEFAULTS.ROWS
  });
  const updateParam = useCallback3(
    (key, values) => {
      searchParams.delete(key);
      values?.forEach((value2) => searchParams.append(key, value2));
      setSearchParams(searchParams, { replace: true });
    },
    [searchParams, setSearchParams]
  );
  const onFilter = useCallback3(
    (key, value2) => {
      updateParam(key, typeof value2 === "object" ? value2 : [value2]);
    },
    [updateParam]
  );
  const onSort = useCallback3(
    ({ sortOrder, sortField }) => {
      if (sortOrder === 0 /* NONE */) {
        onFilter("orderBy" /* ORDER_BY */, null);
        onFilter("sortDirection" /* SORT_DIRECTION */, null);
        return;
      }
      const sortDirection = sortOrder === 1 /* ASC */ ? "Ascending" /* ASCENDING */ : "Descending" /* DESCENDING */;
      onFilter("orderBy" /* ORDER_BY */, sortField);
      onFilter("sortDirection" /* SORT_DIRECTION */, sortDirection);
    },
    [onFilter]
  );
  const onPage = useCallback3(
    ({ page = 0 }) => {
      const pageStr = (page + 1).toString();
      onFilter("pageNumber" /* PAGE_NUMBER */, pageStr);
    },
    [onFilter]
  );
  const params = useMemo(() => {
    const getParam = (key, defaultValue) => searchParams.get(key) || defaultValue;
    const getAllParam = (key, defaultValue) => searchParams.getAll(key) || defaultValue;
    const pageNumber = parseInt(
      getParam("pageNumber" /* PAGE_NUMBER */, DEFAULTS.PAGE)
    );
    const rows = parseInt(getParam("pageSize" /* PAGE_SIZE */, DEFAULTS.ROWS));
    const sortField = searchParams.get("orderBy" /* ORDER_BY */) || void 0;
    const sortDirection = searchParams.get(
      "sortDirection" /* SORT_DIRECTION */
    );
    const getFilter = (key) => getParam(key, null);
    const getAllFilter = (key) => getAllParam(key, null);
    return {
      first: (pageNumber - 1) * rows,
      rows,
      sortField,
      sortOrder: sortDirection === "Ascending" /* ASCENDING */ ? 1 /* ASC */ : -1 /* DESC */,
      getFilter,
      getAllFilter
    };
  }, [searchParams]);
  return {
    params,
    searchParams,
    onPage,
    onSort,
    onFilter
  };
};
var use_table_pagination_default = useTablePagination;

// src/icon-square/index.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
function IconSquare({ bgColor, textColor, ...props }) {
  return /* @__PURE__ */ jsx33(
    "div",
    {
      "data-testid": "icon-square",
      className: cn(
        "flex items-center justify-center text-white size-10 rounded-lg shadow",
        textColor,
        bgColor
      ),
      children: /* @__PURE__ */ jsx33(Icon, { ...props })
    }
  );
}

// src/input/index.tsx
import { InputText } from "primereact/inputtext";

// src/emoji-picker/index.tsx
import { faFaceSmile } from "@fortawesome/free-regular-svg-icons";
import EmojiPicker from "emoji-picker-react";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef as useRef4 } from "react";
import { jsx as jsx34, jsxs as jsxs11 } from "react/jsx-runtime";
function EmojiPickerUI({ onEmojiPicked, ...props }) {
  const op = useRef4(null);
  return /* @__PURE__ */ jsxs11("div", { className: "relative z-10", children: [
    /* @__PURE__ */ jsx34(
      IconButton,
      {
        variant: "link-secondary",
        iconProps: { icon: faFaceSmile },
        onClick: (e) => op.current?.toggle(e),
        type: "button",
        spacing: "none"
      }
    ),
    /* @__PURE__ */ jsx34(
      OverlayPanel,
      {
        ref: op,
        pt: {
          root: {
            className: "rounded-lg"
          },
          content: {
            className: "p-0"
          }
        },
        children: /* @__PURE__ */ jsx34(EmojiPicker, { ...props, onEmojiClick: onEmojiPicked })
      }
    )
  ] });
}

// src/input/index.tsx
import { jsx as jsx35, jsxs as jsxs12 } from "react/jsx-runtime";
function Input({
  id,
  className,
  error,
  helperText,
  placeholder,
  prefix,
  hasEmojiPicker,
  disabled,
  onChange,
  ...props
}) {
  const { textRef, insertEmoji } = useEmojiPickerText({ onChange });
  const isPrefixShown = !props.hidden && prefix;
  const hasError = props.invalid || !!error;
  return /* @__PURE__ */ jsxs12("div", { className: "flex w-full flex-col", children: [
    /* @__PURE__ */ jsxs12("div", { className: "flex", children: [
      isPrefixShown && /* @__PURE__ */ jsx35("span", { className: "flex h-[50px] items-center whitespace-nowrap rounded-l-md border-r border-gray-300 border-r-transparent bg-gray-200 px-3 py-1 text-sm text-gray-600", children: prefix }),
      /* @__PURE__ */ jsx35(
        "div",
        {
          className: cn("relative w-full", {
            "cursor-not-allowed opacity-60 [&]:!cursor-not-allowed": disabled
          }),
          children: /* @__PURE__ */ jsxs12(FloatLabel, { invalid: hasError, children: [
            /* @__PURE__ */ jsx35(
              InputText,
              {
                ...props,
                onChange,
                ref: textRef,
                id,
                disabled,
                className: cn(
                  'bg-white w-full border border-text-secondary/20 text-black focus:border-primary placeholder:overflow-hidden focus:shadow-inset-1 focus:!shadow-primary pr-10 px-3 py-1 min-w-[150px] h-[50px] rounded-md transition-all shadow-none peer-placeholder-shown:text-primary text-sm [&[type="file"]]:leading-[30px] [&[type="file"]]:py-1',
                  className,
                  {
                    "border-error focus:border-error focus:!shadow-error": hasError,
                    "rounded-l-none": isPrefixShown,
                    "border-l-transparent": isPrefixShown && !hasError,
                    "pr-8": hasEmojiPicker
                  }
                )
              }
            ),
            hasEmojiPicker && !disabled && /* @__PURE__ */ jsx35("div", { className: "absolute right-3 top-3", children: /* @__PURE__ */ jsx35(
              EmojiPickerUI,
              {
                onEmojiPicked: insertEmoji,
                previewConfig: { showPreview: false },
                height: "300px",
                width: "100%"
              }
            ) }),
            /* @__PURE__ */ jsx35(
              "label",
              {
                htmlFor: id,
                className: cn({
                  "text-error": hasError
                }),
                children: placeholder
              }
            )
          ] })
        }
      )
    ] }),
    /* @__PURE__ */ jsx35("div", { className: "mt-1 flex w-full gap-2", children: /* @__PURE__ */ jsx35(HelperText, { error, text: helperText }) })
  ] });
}

// src/input-icon/index.tsx
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText as InputText2 } from "primereact/inputtext";
import { jsx as jsx36, jsxs as jsxs13 } from "react/jsx-runtime";
function Input2({
  id,
  className,
  error,
  helperText,
  placeholder,
  ref,
  icon,
  ...props
}) {
  return /* @__PURE__ */ jsxs13("div", { children: [
    /* @__PURE__ */ jsxs13(IconField, { iconPosition: "left", children: [
      /* @__PURE__ */ jsx36(InputIcon, { children: /* @__PURE__ */ jsx36(Icon, { icon, className: "mb-1" }) }),
      /* @__PURE__ */ jsx36(
        InputText2,
        {
          ...props,
          ref,
          id,
          className: cn(
            'bg-white w-full border border-text-secondary/20 text-black focus:border-primary focus:shadow-inset-1 focus:!shadow-primary px-3 py-1 min-w-[150px] h-[58px] rounded-md transition-all shadow-none peer-placeholder-shown:text-primary text-sm [&[type="file"]]:leading-[30px] [&[type="file"]]:py-1.5',
            className,
            {
              "border-error focus:border-error focus:!shadow-error": props.invalid || !!error
            },
            "pl-8"
          ),
          placeholder
        }
      )
    ] }),
    /* @__PURE__ */ jsx36(HelperText, { error, text: helperText })
  ] });
}

// src/input-mask-icon/index.tsx
import { IconField as IconField2 } from "primereact/iconfield";
import { InputIcon as InputIcon2 } from "primereact/inputicon";
import { InputMask } from "primereact/inputmask";
import { jsx as jsx37, jsxs as jsxs14 } from "react/jsx-runtime";
function InputMaskIcon({
  id,
  className,
  error,
  helperText,
  placeholder,
  icon,
  mask,
  ...props
}) {
  return /* @__PURE__ */ jsxs14("div", { children: [
    /* @__PURE__ */ jsxs14(IconField2, { iconPosition: "left", children: [
      /* @__PURE__ */ jsx37(InputIcon2, { children: /* @__PURE__ */ jsx37(Icon, { icon, className: "mb-1" }) }),
      /* @__PURE__ */ jsx37(
        InputMask,
        {
          ...props,
          id,
          mask,
          className: cn(
            'bg-white w-full border border-text-secondary/20 text-black focus:border-primary focus:shadow-inset-1 focus:!shadow-primary px-3 py-1 min-w-[150px] h-[58px] rounded-md transition-all shadow-none peer-placeholder-shown:text-primary text-sm [&[type="file"]]:leading-[30px] [&[type="file"]]:py-1.5',
            className,
            {
              "border-error focus:border-error focus:!shadow-error": props.invalid || !!error
            },
            "pl-8"
          ),
          placeholder
        }
      )
    ] }),
    /* @__PURE__ */ jsx37(HelperText, { error, text: helperText })
  ] });
}

// src/message/index.tsx
import { Message as PrimeMessage } from "primereact/message";
var Message = PrimeMessage;
var message_default = Message;

// src/paginator/index.tsx
import { Paginator as PrimePaginator } from "primereact/paginator";

// src/paginator/paginator.template.tsx
import { Ripple as Ripple2 } from "primereact/ripple";
import { classNames as classNames2 } from "primereact/utils";
import { jsx as jsx38, jsxs as jsxs15 } from "react/jsx-runtime";
var PaginatorTemplateEnum = /* @__PURE__ */ ((PaginatorTemplateEnum2) => {
  PaginatorTemplateEnum2["TEMPLATE_CARROUSEL"] = "templateCarousel";
  return PaginatorTemplateEnum2;
})(PaginatorTemplateEnum || {});
var templateOptions = {
  ["templateCarousel" /* TEMPLATE_CARROUSEL */]: {
    layout: "PrevPageLink PageLinks NextPageLink",
    PageLinks: (options) => {
      if (options.view.startPage === options.page && options.view.startPage !== 0 || options.view.endPage === options.page && options.page + 1 !== options.totalPages) {
        const className = classNames2(options.className, { "p-disabled": true });
        return /* @__PURE__ */ jsx38("span", { className, style: { userSelect: "none" }, children: "..." });
      }
      return /* @__PURE__ */ jsxs15(
        "button",
        {
          type: "button",
          className: `${options.className} rounded-full transition-all hover:bg-[#EAEAF1]/50 [&.p-highlight]:bg-hover-link`,
          onClick: options.onClick,
          children: [
            options.page + 1,
            /* @__PURE__ */ jsx38(Ripple2, {})
          ]
        }
      );
    }
  }
};

// src/paginator/index.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
function Paginator({
  first,
  totalRecords,
  templateOption = "templateCarousel" /* TEMPLATE_CARROUSEL */,
  onPageChange,
  pageLinkSize,
  rows,
  ...props
}) {
  const template = templateOptions?.[templateOption];
  return /* @__PURE__ */ jsx39(
    PrimePaginator,
    {
      ...props,
      first,
      rows,
      totalRecords,
      onPageChange,
      pageLinkSize,
      template
    }
  );
}

// src/panel/index.tsx
import { Panel as PrimePanel } from "primereact/panel";
import { jsx as jsx40 } from "react/jsx-runtime";
function Panel(props) {
  return /* @__PURE__ */ jsx40(PrimePanel, { ...props });
}

// src/picture-uploader/index.tsx
import "cropperjs/dist/cropper.css";
import { useCallback as useCallback5, useState as useState4 } from "react";
import Cropper from "react-cropper";

// src/picture-uploader/hooks/use-picture-uploader/index.ts
import {
  useCallback as useCallback4,
  useRef as useRef5,
  useState as useState3
} from "react";
var readAsDataURL2 = function(file, onReadDataUrl, onError) {
  const reader = new FileReader();
  reader.onloadend = (e) => {
    if (!e.target) {
      onError?.("reader event target is unvailable");
      return;
    }
    if (!e.target.result) {
      onError?.("event target result is unvailable");
      return;
    }
    if (typeof e.target.result !== "string") {
      onError?.("event target result is not a base64 source file");
      return;
    }
    onReadDataUrl(e.target.result);
  };
  reader.readAsDataURL(file);
};
function usePictureUploader({
  value: value2,
  onChange,
  allowedImageTypes,
  onReject
}) {
  const inputRef = useRef5(null);
  const cropperRef = useRef5(null);
  const [isLoading, setIsLoading] = useState3(false);
  const [cropped, setCropped] = useState3(false);
  const handleChange = useCallback4(
    async (e) => {
      const [file] = e.target.files ?? [];
      if (!file) return;
      if (allowedImageTypes?.length && !allowedImageTypes.includes(file.type)) {
        onReject?.(
          "Seuls les formats .jpg, .jpeg et .png sont autoris\xE9s pour les images"
        );
        e.target.value = "";
        return;
      }
      setIsLoading(true);
      readAsDataURL2(
        file,
        (src) => {
          const { name, size, type } = file;
          onChange?.({ src, name, imageType: type, size });
          setIsLoading(false);
        },
        () => setIsLoading(false)
      );
    },
    [onChange, allowedImageTypes, onReject]
  );
  const handleImageLoad = (event) => {
    const { naturalWidth: width, naturalHeight: height } = event.currentTarget;
    onChange?.({ ...value2, resolution: { width, height } });
  };
  const handleRemove = useCallback4(() => {
    if (inputRef.current) inputRef.current.value = "";
    onChange?.(null);
  }, [inputRef, onChange]);
  const cropImage = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      const croppedCanvas = cropper.getCroppedCanvas();
      const croppedDataUrl = croppedCanvas.toDataURL("image/*");
      onChange?.({ ...value2, src: croppedDataUrl });
      setCropped(false);
    }
  };
  return {
    isLoading,
    inputRef,
    cropperRef,
    handleChange,
    handleImageLoad,
    handleRemove,
    cropImage,
    cropped,
    setCropped
  };
}

// src/picture-uploader/index.tsx
import { Fragment as Fragment3, jsx as jsx41, jsxs as jsxs16 } from "react/jsx-runtime";
var DEFAULT_ACCEPT_IMAGES = "image/*";
function PictureUploader({
  accept = DEFAULT_ACCEPT_IMAGES,
  disabled,
  error,
  helperText,
  name,
  placeholder,
  value: value2,
  onChange,
  isCroppable = false,
  allowedRatio = [
    { label: "16:9", value: 16 / 9 },
    { label: "2:1", value: 2 / 1 },
    { label: "7:3", value: 7 / 3 }
  ],
  allowedImageTypes,
  onReject
}) {
  const {
    isLoading,
    inputRef,
    cropperRef,
    cropImage,
    handleChange,
    handleImageLoad,
    handleRemove,
    cropped,
    setCropped
  } = usePictureUploader({
    value: value2,
    onChange,
    allowedImageTypes,
    onReject
  });
  const [aspectRatio, setAspectRatio] = useState4(allowedRatio[0].value);
  const handleSetRatio = useCallback5(
    (aspectRatio2) => {
      setAspectRatio(aspectRatio2);
      const cropper = cropperRef.current?.cropper;
      if (cropper && !isNaN(aspectRatio2)) {
        cropper.setAspectRatio(aspectRatio2);
      }
    },
    [setAspectRatio, cropperRef]
  );
  return /* @__PURE__ */ jsxs16("div", { className: "relative w-full min-w-[200px]", children: [
    /* @__PURE__ */ jsxs16(
      "div",
      {
        className: cn(
          "grid border w-full h-[300px] rounded-md border-t-0 relative p-1",
          { "border-error": error },
          { "border-text-secondary/20": !error }
        ),
        children: [
          /* @__PURE__ */ jsxs16("div", { className: "relative flex size-full items-center justify-center overflow-hidden rounded-md bg-[#f2eaff]", children: [
            !cropped ? !!value2 && (value2.imageType?.startsWith("image/") || disabled && value2.src) && /* @__PURE__ */ jsx41(
              "img",
              {
                className: "block size-auto max-h-full max-w-full",
                alt: value2?.name,
                src: value2?.src,
                onLoad: handleImageLoad
              }
            ) : !!value2 && cropped && (value2.imageType?.startsWith("image/") || disabled && value2.src) && /* @__PURE__ */ jsx41(
              Cropper,
              {
                src: value2?.src,
                className: "size-full object-contain",
                aspectRatio,
                guides: true,
                ref: cropperRef,
                viewMode: 1
              }
            ),
            isLoading && /* @__PURE__ */ jsx41(Loading, { position: "absolute", centered: true })
          ] }),
          /* @__PURE__ */ jsx41("div", { className: "absolute right-3 top-2 flex gap-x-2", children: !disabled && /* @__PURE__ */ jsx41(Fragment3, { children: !cropped ? /* @__PURE__ */ jsxs16(Fragment3, { children: [
            /* @__PURE__ */ jsxs16(
              "label",
              {
                htmlFor: name,
                className: "p-ripple cursor-pointer rounded-lg bg-primary px-4 py-2 text-xs text-white shadow-md transition-all hover:bg-primary/80",
                children: [
                  /* @__PURE__ */ jsx41(Icon, { icon: faPencil, role: "button", id: `${name}-update` }),
                  /* @__PURE__ */ jsx41(Ripple, { variant: "primary" })
                ]
              }
            ),
            /* @__PURE__ */ jsx41(
              "input",
              {
                type: "file",
                id: name,
                accept,
                className: "hidden",
                onChange: handleChange,
                ref: inputRef
              }
            ),
            value2?.src && /* @__PURE__ */ jsxs16(Fragment3, { children: [
              isCroppable && /* @__PURE__ */ jsx41(
                IconButton,
                {
                  name: `${name}-crop-image`,
                  size: "small",
                  type: "button",
                  iconProps: {
                    icon: faCrop
                  },
                  onClick: () => {
                    setAspectRatio(allowedRatio[0].value);
                    setCropped(!cropped);
                  }
                }
              ),
              /* @__PURE__ */ jsx41(
                IconButton,
                {
                  name: `${name}-delete-image`,
                  size: "small",
                  type: "button",
                  iconProps: {
                    icon: faTrashCan
                  },
                  onClick: handleRemove
                }
              )
            ] })
          ] }) : /* @__PURE__ */ jsxs16(Fragment3, { children: [
            allowedRatio.map((ratio) => /* @__PURE__ */ jsx41(
              Button,
              {
                name: `${name}-crop-image-ratio-${ratio.label}`,
                size: "small",
                type: "button",
                onClick: () => handleSetRatio(ratio.value),
                children: ratio.label
              },
              `${name}-crop-image-ratio-${ratio.label}`
            )),
            /* @__PURE__ */ jsx41(
              IconButton,
              {
                name: `${name}-cancel-crop`,
                size: "small",
                type: "button",
                variant: "secondary",
                iconProps: {
                  icon: faBan
                },
                onClick: () => setCropped(!cropped)
              }
            ),
            /* @__PURE__ */ jsx41(
              IconButton,
              {
                name: `${name}-validate-crop`,
                size: "small",
                type: "button",
                iconProps: {
                  icon: faCheck
                },
                onClick: cropImage
              }
            )
          ] }) }) })
        ]
      }
    ),
    /* @__PURE__ */ jsx41(
      "label",
      {
        className: cn(
          "before:content[' '] after:content[' '] pointer-events-none absolute top-[-7px] flex size-full select-none !overflow-visible truncate text-[11px] font-normal leading-tight text-secondary transition-all before:pointer-events-none before:mr-1 before:mt-[6.5px] before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-l before:border-t before:border-text-secondary/20 before:transition-all after:pointer-events-none after:ml-1 after:mt-[6.5px] after:box-border after:block after:h-1.5 after:w-2.5 after:grow after:rounded-tr-md after:border-r after:border-t after:border-text-secondary/20 after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[3.75] peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-secondary peer-focus:before:border-l peer-focus:before:border-t peer-focus:before:border-text-secondary/20 peer-focus:after:border-r peer-focus:after:border-t peer-focus:after:border-text-secondary/20 peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent",
          {
            "text-error before:border-error after:border-error peer-focus:text-error peer-focus:before:!border-error peer-focus:after:!border-error": error
          }
        ),
        children: placeholder
      }
    ),
    /* @__PURE__ */ jsx41(HelperText, { error, text: helperText })
  ] });
}

// src/popup-menu/index.tsx
import { Menu as Menu2 } from "primereact/menu";
import { useRef as useRef6 } from "react";
import { jsx as jsx42, jsxs as jsxs17 } from "react/jsx-runtime";
function PopupMenu({ items }) {
  const menuLeft = useRef6(null);
  return /* @__PURE__ */ jsxs17("div", { className: "flex justify-start", children: [
    /* @__PURE__ */ jsx42(
      Menu2,
      {
        model: items,
        popup: true,
        ref: menuLeft,
        pt: {
          root: { className: "min-w-[120px] w-auto" },
          menu: { className: "bg-white rounded-lg" },
          menuitem: (options) => ({
            className: cn(
              "flex items-center w-full hover:bg-slate-100 cursor-pointer text-sm shadow-none",
              {
                "opacity-50 pointer-events-none cursor-none": options?.context.item.disabled
              }
            )
          })
        }
      }
    ),
    /* @__PURE__ */ jsx42(
      "button",
      {
        className: "mr-2",
        onClick: (event) => menuLeft.current?.toggle?.(event),
        "aria-controls": "popup_menu_left",
        "aria-haspopup": true,
        children: /* @__PURE__ */ jsx42(Icon, { icon: faBars })
      }
    )
  ] });
}

// src/popup-menu/items/button-template/index.tsx
import { jsx as jsx43, jsxs as jsxs18 } from "react/jsx-runtime";
function buttonTemplate({
  color = "normal",
  disabled,
  icon,
  label,
  onClick
}) {
  return {
    label,
    disabled,
    template: (item) => /* @__PURE__ */ jsxs18(
      "div",
      {
        role: "button",
        className: cn(
          "w-full p-2 inline-flex justify-between items-center gap-2",
          {
            "text-error": color === "delete"
          }
        ),
        onClick,
        children: [
          item.label,
          /* @__PURE__ */ jsx43(Icon, { icon })
        ]
      }
    )
  };
}

// src/popup-menu/items/delete-template/index.tsx
import { confirmDialog as confirmDialog2 } from "primereact/confirmdialog";
function deleteTemplate({
  disabled,
  messageConfirmDelete,
  onConfirmDelete
}) {
  const handleClickDelete = () => {
    confirmDialog2({
      message: messageConfirmDelete,
      defaultFocus: "reject",
      accept: onConfirmDelete
    });
  };
  return buttonTemplate({
    color: "delete",
    disabled,
    icon: faTrash,
    label: "Supprimer",
    onClick: handleClickDelete
  });
}

// src/popup-menu/items/link-template/index.tsx
import { Link as Link3 } from "react-router-dom";
import { jsx as jsx44, jsxs as jsxs19 } from "react/jsx-runtime";
function linkTemplate({
  disabled,
  icon,
  label,
  to
}) {
  return {
    label,
    template: (item) => /* @__PURE__ */ jsxs19(
      Link3,
      {
        role: "button",
        className: cn(
          "w-full p-2 inline-flex justify-between items-center gap-2",
          {
            "opacity-50 pointer-events-none cursor-none": item.disabled
          }
        ),
        to,
        children: [
          item.label,
          /* @__PURE__ */ jsx44(Icon, { icon })
        ]
      }
    ),
    disabled
  };
}

// src/popup-menu/items/update-template/index.tsx
function updateTemplate({ disabled, to }) {
  return linkTemplate({
    disabled,
    label: "Modifier",
    icon: faPen,
    to
  });
}

// src/prime-color-picker/index.tsx
import { ColorPicker as ColorPicker2 } from "primereact/colorpicker";
var prime_color_picker_default = ColorPicker2;

// src/providers/stepper-provider/index.tsx
import { useCallback as useCallback6, useMemo as useMemo2, useRef as useRef7, useState as useState5 } from "react";
import { jsx as jsx45 } from "react/jsx-runtime";
function StepperProvider({
  initialStep = 0,
  children,
  triggerStepper = () => null,
  triggeredStepper
}) {
  const stepperRef = useRef7(null);
  const stepperHeaderEndRef = useRef7(null);
  const [activeStepState, setActiveStepState] = useState5(initialStep);
  const goToStep = useCallback6(async (step) => {
    const changeStepValue = stepperRef.current?.onChangeStep();
    if (changeStepValue instanceof Promise && await changeStepValue === false)
      return;
    if (changeStepValue === false) return;
    setActiveStepState(step);
  }, []);
  const prevStep = useCallback6(() => setActiveStepState((prev) => prev - 1), []);
  const nextStep = useCallback6(() => setActiveStepState((prev) => prev + 1), []);
  const value2 = useMemo2(
    () => ({
      activeStep: activeStepState,
      stepperHeaderEndRef,
      stepperRef,
      triggeredStepper,
      goToStep,
      prevStep,
      nextStep,
      triggerStepper
    }),
    [
      activeStepState,
      triggeredStepper,
      goToStep,
      prevStep,
      nextStep,
      triggerStepper
    ]
  );
  return /* @__PURE__ */ jsx45(StepperContext.Provider, { value: { ...value2 }, children });
}

// src/providers/toast-provider/index.tsx
import { useCallback as useCallback7, useMemo as useMemo3, useRef as useRef8 } from "react";

// src/toast/index.tsx
import { Toast as PrimeToast } from "primereact/toast";
import { jsx as jsx46 } from "react/jsx-runtime";
function Toast({ ref, ...props }) {
  return /* @__PURE__ */ jsx46(
    PrimeToast,
    {
      ref,
      position: "bottom-center",
      className: "bg-white",
      pt: {
        message: ({ state, index }) => ({
          className: cn("border-l-8 rounded", {
            "bg-success/10 border-l-success": state.messages[index]?.message.severity == "success",
            "bg-warning/10 border-l-warning": state.messages[index]?.message.severity == "warning",
            "bg-error/10 border-l-error": state.messages[index]?.message.severity == "error"
          })
        }),
        content: { className: "flex gap-2 items-center" },
        icon: ({ state, index }) => ({
          className: cn("size-6", {
            "text-success": state.messages[index]?.message.severity == "success",
            "text-warning": state.messages[index]?.message.severity == "warning",
            "text-error": state.messages[index]?.message.severity == "error"
          })
        }),
        summary: { className: "text-md" },
        detail: { className: "text-xs" }
      },
      ...props
    }
  );
}

// src/providers/toast-provider/index.tsx
import { jsx as jsx47, jsxs as jsxs20 } from "react/jsx-runtime";
function ToastProvider({ children }) {
  const toastRef = useRef8(null);
  const showMessage = useCallback7(
    (message, resetOnShow = true) => {
      if (resetOnShow) toastRef.current?.clear();
      toastRef.current?.show(message);
    },
    []
  );
  const clear = useCallback7(() => toastRef.current?.clear(), []);
  const value2 = useMemo3(() => ({ clear, showMessage }), [showMessage, clear]);
  return /* @__PURE__ */ jsxs20(ToastContext.Provider, { value: value2, children: [
    children,
    /* @__PURE__ */ jsx47(Toast, { ref: toastRef })
  ] });
}

// src/radio-button/index.tsx
import { RadioButton as PrimeRadioButton } from "primereact/radiobutton";
import { jsx as jsx48, jsxs as jsxs21 } from "react/jsx-runtime";
function RadioButton({
  id,
  className,
  error,
  helperText,
  label,
  ...props
}) {
  return /* @__PURE__ */ jsxs21("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ jsxs21("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx48(
        PrimeRadioButton,
        {
          ...props,
          inputId: id,
          className: cn(
            "p-radiobutton rounded-full transition-all",
            "[&_.p-radiobutton-box]:border-2 [&_.p-radiobutton-box]:border-primary [&_.p-radiobutton-box]:border-solid",
            "[&_.p-radiobutton-box]:shadow-none [&_.p-radiobutton-box]:flex [&_.p-radiobutton-box]:items-center [&_.p-radiobutton-box]:justify-center",
            "[&_.p-radiobutton-icon]:w-3 [&_.p-radiobutton-icon]:h-3 [&_.p-radiobutton-icon]:bg-primary [&_.p-radiobutton-icon]:rounded-full",
            "[&_.p-radiobutton-box.p-highlight]:border-primary [&_.p-radiobutton-box.p-highlight]:bg-white",
            "[&_.p-radiobutton-icon.p-highlight]:bg-primary",
            className,
            {
              "border-error focus:ring-error focus:border-error": error,
              "[&_.p-radiobutton-box.p-highlight]:border-error [&_.p-radiobutton-icon]:bg-error": error
            }
          )
        }
      ),
      label && /* @__PURE__ */ jsx48(
        "label",
        {
          htmlFor: id,
          className: cn("text-sm", { "text-error": error }),
          children: label
        }
      )
    ] }),
    helperText && /* @__PURE__ */ jsx48(HelperText, { error, text: helperText })
  ] });
}

// src/select/index.tsx
import { Dropdown } from "primereact/dropdown";
import { Fragment as Fragment4, jsx as jsx49, jsxs as jsxs22 } from "react/jsx-runtime";
function Select({
  id,
  emptyMessage = "Aucun r\xE9sultat",
  name,
  placeholder,
  error,
  ...props
}) {
  return /* @__PURE__ */ jsxs22(Fragment4, { children: [
    /* @__PURE__ */ jsxs22(FloatLabel, { invalid: props.invalid || !!error, children: [
      /* @__PURE__ */ jsx49(
        Dropdown,
        {
          id: id ?? name,
          ...props,
          emptyMessage,
          pt: {
            root: (options) => ({
              className: cn(
                "shadow-transparent min-w-[150px] w-full rounded-md border border-text-secondary/20 min-h-[50px]",
                "hover:border-blue-500 focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]",
                "border-blue-900/40 hover:border-blue-300",
                {
                  "shadow-none": !options?.state?.focused,
                  "shadow-inset-1 border-primary !shadow-primary": !!options?.state?.focused
                },
                {
                  "border-error focus:border-error focus:!shadow-error": props.invalid || !!error
                }
              )
            }),
            input: {
              className: "px-3"
            },
            item: (options) => ({
              className: cn("bg-white hover:bg-primary/10 transition-all", {
                " bg-primary/20 text-primary ": !!options?.context.selected || !!options?.context.disabled
              })
            })
          }
        }
      ),
      /* @__PURE__ */ jsx49(
        "label",
        {
          htmlFor: id ?? name,
          className: cn({ "text-error": props.invalid || !!error }),
          children: placeholder
        }
      )
    ] }),
    /* @__PURE__ */ jsx49(HelperText, { error })
  ] });
}

// src/select-multiple/index.tsx
import { MultiSelect } from "primereact/multiselect";
import { jsx as jsx50, jsxs as jsxs23 } from "react/jsx-runtime";
function SelectMultiple({
  placeholder,
  options = [],
  optionLabel,
  value: value2,
  onChange,
  disabled = false
}) {
  return /* @__PURE__ */ jsx50(
    MultiSelect,
    {
      value: value2,
      onChange: (event) => onChange(event.value),
      options,
      optionLabel,
      placeholder,
      disabled,
      "aria-disabled": disabled,
      filter: true,
      className: "min-w-[150px] rounded-md border px-4 py-1 transition-all hover:bg-secondary/5",
      filterTemplate: (props) => /* @__PURE__ */ jsx50(
        Input,
        {
          onChange: (event) => props.onFilter(event),
          placeholder: "Rechercher..."
        }
      ),
      panelHeaderTemplate: (props) => /* @__PURE__ */ jsxs23("div", { className: "flex items-center gap-2 px-2", children: [
        props.checkboxElement,
        props.filterElement,
        props.closeElement
      ] }),
      panelClassName: "bg-white shadow pt-4",
      itemClassName: "p-2 hover:bg-primary/10 transition-all flex items-center gap-2 pointer"
    }
  );
}

// src/side-bar/index.tsx
import { Sidebar as PrimeSidebar } from "primereact/sidebar";
import { jsx as jsx51 } from "react/jsx-runtime";
function Sidebar(props) {
  return /* @__PURE__ */ jsx51(
    PrimeSidebar,
    {
      ...props,
      pt: {
        header: {
          className: "p-4"
        },
        content: {
          className: "pb-3 px-4"
        }
      }
    }
  );
}

// src/skeleton/index.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
function Skeleton({ className, rounded = true }) {
  return /* @__PURE__ */ jsx52("div", { role: "status", className: "max-w-sm animate-pulse", children: /* @__PURE__ */ jsx52(
    "div",
    {
      className: cn("h-2.5 bg-gray-200 dark:bg-gray-400 mb-4", className, {
        "rounded-full": rounded
      })
    }
  ) });
}

// src/slider/index.tsx
import {
  Slider as PrimeSlider
} from "primereact/slider";
var Slider = PrimeSlider;
var slider_default = Slider;

// src/stepper/components/step-item/index.tsx
import { jsx as jsx53, jsxs as jsxs24 } from "react/jsx-runtime";
function StepItem({
  linear,
  index,
  title,
  subtitle,
  isActive,
  showSeparator
}) {
  const { goToStep, activeStep } = useStepperContext();
  const handleClickStep = () => {
    if (linear || activeStep === index) return;
    goToStep(index);
  };
  return /* @__PURE__ */ jsxs24(
    "div",
    {
      role: linear || activeStep !== index ? "none" : "button",
      className: cn("flex items-center", {
        "w-full": showSeparator,
        "cursor-pointer": !linear
      }),
      onClick: handleClickStep,
      children: [
        /* @__PURE__ */ jsxs24("div", { "data-testid": "step-item", className: "text-center", children: [
          /* @__PURE__ */ jsx53(
            "div",
            {
              className: cn(
                "transition-all size-6 rounded-full m-auto mb-2 shadow shadow-primary bg-white",
                { "bg-primary": isActive },
                {
                  "hover:bg-primary/20": !linear && activeStep !== index
                }
              ),
              children: /* @__PURE__ */ jsx53(Icon, { icon: faCheck, className: "text-white" })
            }
          ),
          /* @__PURE__ */ jsx53("div", { className: "mb-1 text-sm font-bold", children: title }),
          /* @__PURE__ */ jsx53("div", { className: "text-nowrap text-xs", children: subtitle })
        ] }),
        showSeparator && /* @__PURE__ */ jsx53(
          "div",
          {
            className: cn("w-full h-[3px] bg-primary/10", {
              "bg-primary": activeStep > index
            })
          }
        )
      ]
    }
  );
}

// src/stepper/components/default-header-template/index.tsx
import { jsx as jsx54, jsxs as jsxs25 } from "react/jsx-runtime";
import { createElement } from "react";
function DefaultHeaderTemplate({
  activeStep,
  items,
  title,
  linear
}) {
  const { stepperHeaderEndRef } = useStepperContext();
  return /* @__PURE__ */ jsxs25("div", { className: "flex justify-between gap-4", children: [
    /* @__PURE__ */ jsx54("div", { className: "flex flex-initial items-center", children: /* @__PURE__ */ jsx54(Heading1, { children: title }) }),
    /* @__PURE__ */ jsx54("div", { className: "flex max-w-1/2 grow justify-center", children: items.map((item, index) => /* @__PURE__ */ createElement(
      StepItem,
      {
        ...item,
        isActive: activeStep >= index,
        key: item.title,
        index,
        linear,
        showSeparator: index < items.length - 1
      }
    )) }),
    /* @__PURE__ */ jsx54("div", { className: "flex-initial items-end", ref: stepperHeaderEndRef })
  ] });
}

// src/stepper/index.tsx
import { jsx as jsx55, jsxs as jsxs26 } from "react/jsx-runtime";
var StepperComponent = function({
  headerTemplate,
  items,
  linear = true,
  title
}) {
  const { activeStep } = useStepperContext();
  const HeaderTemplateComponent = headerTemplate ?? DefaultHeaderTemplate;
  const { content: StepperContentComponent } = items[activeStep];
  return /* @__PURE__ */ jsxs26("div", { className: "flex h-full flex-col gap-4", children: [
    /* @__PURE__ */ jsx55(
      HeaderTemplateComponent,
      {
        linear,
        activeStep,
        items: items.map(({ header }) => header),
        title
      }
    ),
    /* @__PURE__ */ jsx55(StepperContentComponent, {})
  ] });
};
function Stepper({
  triggerStepper,
  triggeredStepper,
  initialStep,
  ...props
}) {
  return /* @__PURE__ */ jsx55(
    StepperProvider,
    {
      triggeredStepper,
      triggerStepper,
      initialStep,
      children: /* @__PURE__ */ jsx55(StepperComponent, { ...props })
    }
  );
}

// src/stepper/components/stepper-header-end-portal/index.tsx
import { createPortal } from "react-dom";
import { Fragment as Fragment5, jsx as jsx56 } from "react/jsx-runtime";
function StepperHeaderEndPortal({ children }) {
  const { stepperHeaderEndRef } = useStepperContext();
  return /* @__PURE__ */ jsx56(Fragment5, { children: stepperHeaderEndRef?.current && createPortal(children, stepperHeaderEndRef.current) });
}

// src/switch/index.tsx
import { InputSwitch } from "primereact/inputswitch";
import { classNames as classNames3 } from "primereact/utils";
import { jsx as jsx57, jsxs as jsxs27 } from "react/jsx-runtime";
function Switch({ label, ...props }) {
  return /* @__PURE__ */ jsxs27("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ jsx57(
      InputSwitch,
      {
        ...props,
        pt: {
          root: ({ props: props2 }) => ({
            className: classNames3("inline-block relative", "w-10 h-4", {
              "opacity-60 select-none pointer-events-none cursor-default": props2.disabled
            })
          }),
          input: {
            className: classNames3(
              "absolute appearance-none top-0 left-0 size-full p-0 m-0 opacity-0 z-10 outline-none cursor-pointer"
            )
          },
          slider: ({ props: props2 }) => ({
            className: classNames3(
              "absolute cursor-pointer top-0 left-0 right-0 bottom-0 border border-transparent",
              "transition-colors duration-200 rounded-2xl",
              "focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]",
              "before:absolute before:content-'' before:top-1/2 before:bg-primary before:size-6 before:-mt-3 before:rounded-full before:transition-duration-200",
              {
                "bg-gray-200 hover:bg-gray-300 before:bg-slate-300": !props2.checked,
                "bg-primary/50 before:transform before:translate-x-5": props2.checked
              }
            )
          })
        }
      }
    ),
    label
  ] });
}

// src/tab/index.tsx
import { TabPanel, TabView } from "primereact/tabview";
import { useState as useState6 } from "react";
import { jsx as jsx58 } from "react/jsx-runtime";
function Tab({ items = [], size }) {
  const [activeIndex, setActiveIndex] = useState6(0);
  return /* @__PURE__ */ jsx58(
    TabView,
    {
      activeIndex,
      onTabChange: (e) => setActiveIndex(e.index),
      pt: {
        nav: {
          className: "flex gap-8 item-center border-b border-b-text-secondary/10"
        },
        tab: { className: "bg-red-400" },
        inkbar: { className: "bg-primary" }
      },
      children: items.map((item, index) => /* @__PURE__ */ jsx58(
        TabPanel,
        {
          ...item,
          pt: {
            headerTitle: {
              className: cn("font-thin", {
                "font-bold": activeIndex === index
              })
            }
          },
          headerClassName: cn(
            "flex items-center justify-center h-12 text-sm uppercase border-b-2 border-b-transparent whitespace-nowrap transition-all font-normal",
            {
              "text-primary": activeIndex === index,
              "cursor-pointer font-thin": activeIndex !== index,
              "w-full": size === "full"
            }
          ),
          contentClassName: "py-2"
        },
        index
      ))
    }
  );
}

// src/table/index.tsx
import {
  Column
} from "primereact/column";
import { DataTable } from "primereact/datatable";

// src/table/columns.styles.ts
var COLUMN_TAILWIND = {
  headerCell: {
    className: "first:pl-4 last:pr-4 text-xs uppercase"
  },
  bodyCell: { className: "first:pl-4 last:pr-4 text-sm" }
};

// src/table/components/default-show-total-records-template/index.tsx
import { jsxs as jsxs28 } from "react/jsx-runtime";
function DefaultShowTotalRecordsTemplate({
  totalRecords
}) {
  return /* @__PURE__ */ jsxs28("div", { className: "flex items-center text-sm opacity-50", children: [
    "Nombre de lignes : ",
    totalRecords
  ] });
}

// src/table/tables.styles.ts
var TABLE_TAILWIND = {
  column: {
    headerCheckbox: { input: { className: "border border-lightGrey" } },
    rowCheckbox: {
      input: { className: "bg-black border border-lightGrey" }
    }
  },
  loadingIcon: { className: "size-12" },
  headerRow: {
    className: "h-12 bg-[#F9FAFC] "
  },
  tbody: {
    className: "bg-[#EAEBED] border border-lightGrey"
  },
  bodyRow: {
    className: "bg-white h-12 border border-[#E1E1E2] [&.p-highlight]:bg-primary/20"
  },
  paginator: {
    left: { className: "absolute left-3" },
    root: { className: "mt-5 flex items-center justify-center" },
    end: { className: "absolute right-3" },
    pages: { className: "flex gap-2" },
    pageButton: {
      className: "size-10 hover:bg-[#EAEAF1]/50 transition-all rounded-full [&.p-highlight]:bg-[#EAEAF1]"
    },
    firstPageButton: {
      className: "size-10 hover:bg-white transition-all rounded-full disabled:opacity-20"
    },
    lastPageButton: {
      className: "size-10 hover:bg-white transition-all rounded-full disabled:opacity-20"
    },
    prevPageButton: {
      className: "size-10 hover:bg-white transition-all rounded-full disabled:opacity-20"
    },
    nextPageButton: {
      className: "size-10 hover:bg-white transition-all rounded-full disabled:opacity-20"
    }
  }
};

// src/table/index.tsx
import { jsx as jsx59 } from "react/jsx-runtime";
import { createElement as createElement2 } from "react";
function Table({
  columns,
  emptyMessage = "Aucun r\xE9sultat",
  lazy = true,
  paginator = true,
  paginatorRight,
  rows = 10,
  showTotalRecords,
  stripedRows = true,
  totalRecords,
  value: value2,
  ...tableProps
}) {
  return /* @__PURE__ */ jsx59("div", { "data-testid": "table", className: "relative", children: /* @__PURE__ */ jsx59(
    DataTable,
    {
      ...tableProps,
      tableStyle: { minWidth: "50rem", width: "100%" },
      tableClassName: cn("border", { "text-sm": !value2?.length }),
      stripedRows,
      paginator,
      lazy,
      loadingIcon: /* @__PURE__ */ jsx59(Loading, {}),
      emptyMessage,
      rows,
      pt: TABLE_TAILWIND,
      totalRecords,
      value: value2,
      paginatorRight: showTotalRecords ? /* @__PURE__ */ jsx59(DefaultShowTotalRecordsTemplate, { totalRecords }) : paginatorRight,
      children: columns.map((column, index) => /* @__PURE__ */ createElement2(
        Column,
        {
          ...column,
          key: `${column.field}_${index}`,
          pt: COLUMN_TAILWIND
        }
      ))
    }
  ) });
}

// src/text-area/index.tsx
import {
  InputTextarea
} from "primereact/inputtextarea";
import { jsx as jsx60, jsxs as jsxs29 } from "react/jsx-runtime";
function TextArea({
  id,
  className,
  error,
  helperText,
  placeholder,
  rows = 4,
  value: value2,
  onChange,
  hasEmojiPicker = false,
  ...props
}) {
  const { textRef, insertEmoji } = useEmojiPickerText({ onChange });
  return /* @__PURE__ */ jsxs29("div", { children: [
    /* @__PURE__ */ jsxs29("div", { className: "relative w-full", children: [
      /* @__PURE__ */ jsxs29(FloatLabel, { invalid: props.invalid || !!error, children: [
        /* @__PURE__ */ jsx60(
          InputTextarea,
          {
            ...props,
            onChange,
            value: value2,
            ref: textRef,
            id,
            pt: {
              root: {
                className: cn(
                  "transition-all bg-white w-full border border-text-secondary/20 text-black focus:border-primary p-3 min-w-[150px] rounded-md peer-placeholder-shown:text-primary text-sm resize-none scrollbar-transparent",
                  "focus:shadow-inset-1 focus:!shadow-primary",
                  className,
                  {
                    "border-error focus:border-error focus:!shadow-error": props.invalid || !!error,
                    "pr-10 pb-10": hasEmojiPicker
                  }
                )
              }
            },
            rows
          }
        ),
        /* @__PURE__ */ jsx60(
          "label",
          {
            htmlFor: id,
            className: cn({ "text-error": props.invalid || !!error }),
            children: placeholder
          }
        )
      ] }),
      hasEmojiPicker && /* @__PURE__ */ jsx60("div", { className: "absolute bottom-3 right-3", children: /* @__PURE__ */ jsx60(
        EmojiPickerUI,
        {
          onEmojiPicked: insertEmoji,
          previewConfig: { showPreview: false },
          height: "300px",
          width: "100%"
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx60("div", { className: "mt-1 flex gap-2", children: /* @__PURE__ */ jsx60(HelperText, { error, text: helperText }) })
  ] });
}

// src/toggle-button/index.tsx
import { jsx as jsx61 } from "react/jsx-runtime";
function ToggleButton({
  defaultVariant = "text",
  selected,
  ...props
}) {
  return /* @__PURE__ */ jsx61(
    Button,
    {
      "aria-pressed": selected,
      variant: selected ? "primary" : defaultVariant,
      ...props
    }
  );
}

// src/tooltip/index.tsx
import { Tooltip as PrimeTooltip } from "primereact/tooltip";
import { jsx as jsx62 } from "react/jsx-runtime";
function Tooltip(props) {
  return /* @__PURE__ */ jsx62(PrimeTooltip, { ...props });
}

// src/ui-provider/index.tsx
import { PrimeReactProvider } from "primereact/api";
import { jsx as jsx63, jsxs as jsxs30 } from "react/jsx-runtime";
var value = {
  ripple: true
};
function UIProvider({ children }) {
  return /* @__PURE__ */ jsxs30(PrimeReactProvider, { value, children: [
    children,
    /* @__PURE__ */ jsx63(ConfirmDialog, {})
  ] });
}
export {
  Accordion,
  AccordionTab,
  ActionLink,
  AppLink,
  AutoComplete,
  Badge,
  Button,
  Calendar,
  Card,
  Chart,
  Chip,
  ColorPicker,
  Column,
  ConfirmDialog,
  CustomIcon,
  Dialog,
  EmojiPickerUI as EmojiPicker,
  FileUploader,
  Heading1,
  Heading2,
  HelperText,
  Icon,
  IconButton,
  IconSquare,
  Input,
  Input2 as InputIcon,
  InputMaskIcon,
  Loading,
  message_default as Message,
  Paginator,
  PaginatorTemplateEnum,
  Panel,
  PictureUploader,
  PopupMenu,
  prime_color_picker_default as PrimeColorPicker,
  RadioButton,
  Ripple,
  Select,
  SelectMultiple,
  Sidebar,
  Skeleton,
  slider_default as Slider,
  StepItem,
  Stepper,
  StepperContext,
  StepperHeaderEndPortal,
  StepperProvider,
  Switch,
  Tab,
  Table,
  TextArea,
  Toast,
  ToastContext,
  ToastProvider,
  ToggleButton,
  Tooltip,
  UIProvider,
  buttonTemplate,
  cn,
  confirmDialogFn as confirmDialog,
  deleteTemplate,
  faAlignLeft,
  faAnglesLeft,
  faAnglesRight,
  faArrowLeft,
  faArrowRotateRight,
  faBan,
  faBars,
  faBell,
  faCalendarAlt,
  faCamera,
  faChartLine,
  faChartSimple,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleInfo,
  faCircleNotch,
  faCopy,
  faCrop,
  faDownload,
  faEllipsis,
  faEnvelope,
  faEye,
  faFilter,
  faGear,
  faGlobeEurope,
  faHandshakeSimple,
  faHourglassHalf,
  faImage,
  faImages,
  faLink,
  faLocationDot,
  faMagnifyingGlass,
  faMapMarkerAlt,
  faMobile,
  faMobileScreen,
  faPaperclip,
  faPause,
  faPen,
  faPenToSquare,
  faPencil,
  faPhone,
  faPlay,
  faPlus,
  faPlusCircle,
  faQuestion,
  faQuestionCircle,
  faReply,
  faShield,
  faShieldHalved,
  faSmile,
  faTable,
  faThumbsDown,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashCan,
  faTriangleExclamation2 as faTriangleExclamation,
  faUpload,
  faUser,
  faUserSecret,
  faVolumeHigh,
  faWarning,
  faXmark,
  linkTemplate,
  updateTemplate,
  useEmojiPickerText,
  useHorizontalScrollbar,
  useStepperContext,
  useStepperHandle,
  use_table_pagination_default as useTablePagination,
  useToastContext
};
